import React, { Component } from "react";
import {
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBRow,
    MDBCol,
    MDBInput,
    MDBStepper,
    MDBStep,
    MDBSelect,
    MDBSelectInput,
    MDBSelectOptions,
    MDBSpinner,
    toast,
    MDBProgress,
    MDBTooltip,
    MDBIcon,
} from "mdbreact";
import axios from "../../../../axios";
import "react-phone-number-input/style.css";
import PhoneInput, {
    isPossiblePhoneNumber,
    isValidPhoneNumber,
} from "react-phone-number-input";
import { withTranslation } from "react-i18next";
import $ from "jquery";
import {
    CountryDropdown,
    RegionDropdown,
} from "vault-react-country-region-selector";
import SelectSearch, { fuzzySearch } from "react-select-search";
import VenueServicePlansTable from "../../../../components/NetworkMgmt/Venues/Datatables/VenueServicePlansTable";
import AddServicePlanToVenue from "../../../../components/NetworkMgmt/Forms/AddServicePlanToVenue/AddServicePlanToVenue";
import AddServicePlan from "../../../../components/NetworkMgmt/Forms/AddServicePlan/AddServicePlan";
import VenueEquipmentTable from "../../../../components/NetworkMgmt/Venues/Datatables/VenueEquipmentTable";
import AddVenueEquipment from "../../../../components/NetworkMgmt/Forms/AddVenueEquipment/AddVenueEquipment";
import ModifyEquipment from "../../../../components/NetworkMgmt/Forms/ModifyEquipment/ModifyEquipment";
import VenueKeypoolsTable from "../../../../components/NetworkMgmt/Venues/Datatables/VenueKeypoolsTable";
import AddKeypool from "../../../../components/NetworkMgmt/Forms/AddKeypool/AddKeypool";
import VenueAdministratorsTable from "../../../../components/NetworkMgmt/Venues/Datatables/VenueAdministratorsTable";
import AddVenueAdministrator from "../../../../components/NetworkMgmt/Forms/AddVenueAdministrator/AddVenueAdministrator";
import CSVReader from "react-csv-reader";
const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    quotes: true,
    transformHeader: (header) => header.toLowerCase().replace(/\W/g, "_"),
};
class AddVenue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: null,
            content: null,
            venueName: undefined,
            address1: undefined,
            address2: undefined,
            city: undefined,
            state: undefined,
            postalcode: undefined,
            country: undefined,
            phoneNumber: undefined,
            phone: undefined,
            email: undefined,
            region: undefined,
            value: "en",
            countdown: undefined,
            timezone: undefined,
            loading_prop_groups: false,
            invalidPhone: null,
            invalidCountry: null,
            invalidState: null,
            durationResident: 0,
            durationGuest: 0,
            durationRoaming: 0,
            minVlanRes: 1,
            maxVlanRes: 4000,
            minVlanGuest: 1,
            maxVlanGuest: 4000,
            minVlanRoaming: 1,
            maxVlanRoaming: 4000,
            venueTypeOptions: [
                { value: "WIRED+WIFI", name: "Wi-Fi and Wired Access" },
                {
                    value: "WIRED",
                    name: "Wired Access Only",
                },
            ],
            formActivePanel1:
                this.props.tabNumber === undefined ? 1 : this.props.tabNumber,
            formActivePanel1Changed:
                this.props.tabChanged === undefined
                    ? false
                    : this.props.tabChanged,
            modalAddServicePlan: false,
            modalAddServicePlanToVenue: false,
            servicePlans: this.props.servicePlans,
            selectDefaultServicePlanResident:
                this.props.selectDefaultServicePlanResident,
            selectDefaultServicePlanWireless:
                this.props.selectDefaultServicePlanWireless,
            selectDefaultServicePlanRoaming:
                this.props.selectDefaultServicePlanRoaming,
            venueEquipList: this.props.venueEquipList,
            staffArrayAll: this.props.staffArrayAll,
            lastProcessed: undefined,
            trialCyclesOptions: [
                { value: -1, name: -1 },
                { value: 0, name: 0 },
                { value: 1, name: 1 },
            ],
            venueID: this.props.venueID,
            toggleConfirmContinue: this.props.toggleConfirmContinue,
            allowOverlapping: this.props.allowOverlapping,
            sendSubscriptionAddedEmail: true,
            sendSubscriptionEndEmail: true,
            addedVenue: false,
            enableShoppingCart: JSON.parse(
                sessionStorage.getItem("cartEnabledGlobally")
            ),
            PMSEnableUnitSync: false,
            PMSEnableSubscriberSync: false,
            realpageSiteId: " ",
            entrataPropertyId: " ",
            PMSSyncDate: "",
            PMSBlacklistedEmails: [],
            PMSBlacklistedEmailInput: "",
            // PMS Profile Selection state variables
            pmsProfileOptions: [],
            selectedPMSProfile: null,
            selectedPMSProfileInfo: null,
            loading_pms_profiles: false,
            servicePlansRetryCount: 0,
            servicePlansMaxRetries: 20,
            servicePlansRetryInterval: null,
            servicePlansTimerInterval: null,
            servicePlansElapsedSeconds: 0,
            isOnStep3: false,
            modalServicePlansLoading: false,
        };
    }
    componentDidMount() {
        this.getPropertyManagementGroups();
        this.getKeyPools();
        this.fetchPMSProfiles();
    }
    componentWillUnmount() {
        // Clean up retry interval if it exists
        if (this.state.servicePlansRetryInterval) {
            clearInterval(this.state.servicePlansRetryInterval);
        }
        if (this.state.servicePlansTimerInterval) {
            clearInterval(this.state.servicePlansTimerInterval);
        }
        // Hide the modal if it's open
        if (this.state.modalServicePlansLoading) {
            this.setState({ modalServicePlansLoading: false });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // console.log("🚀 ~ file: AddVenueWizard.js:111 ~ AddVenue ~ componentDidUpdate ~ this.state:", this.state)
        // console.log("🚀 ~ file: AddVenueWizard.js:111 ~ AddVenue ~ componentDidUpdate ~ this.props:", this.props)
        if (this.props.tabNumber !== prevState.tabNumber) {
            // Check if servicePlans is empty or undefined when navigating to Step 3 (Service Plans)
            if (this.props.tabNumber === 3) {
                const servicePlans = this.props.servicePlans;
                const isEmpty = !servicePlans || 
                              (Array.isArray(servicePlans) && servicePlans.length === 0) ||
                              (typeof servicePlans === 'object' && Object.keys(servicePlans).length === 0);
                console.log('Step 3 Navigation (Props) - servicePlans:', servicePlans);
                console.log('Step 3 Navigation (Props) - isEmpty:', isEmpty);
                console.log('Step 3 Navigation (Props) - venueID:', this.props.venueID);
                if (isEmpty) {
                    // Start retry mechanism for service plans
                    if (this.props.venueID && this.props.getVenueDetails) {
                        console.log('Starting service plans retry mechanism (Props change)');
                        this.props.getVenueDetails(this.props.venueID);
                        this.startServicePlansRetry();
                    }
                } else {
                    // Service plans are available, ensure retry is stopped
                    this.setState({ isOnStep3: true });
                    this.stopServicePlansRetry();
                }
            } else {
                // Not navigating to step 3, stop retry if it's running
                this.setState({ isOnStep3: false });
                this.stopServicePlansRetry();
            }
            this.setState({
                tabNumber: this.props.tabNumber,
                tabChanged: this.props.tabChanged,
                formActivePanel1: this.props.tabNumber,
                formActivePanel1Changed: this.props.tabChanged,
            });
        }
        if (this.props.venueEquipList !== prevState.venueEquipList) {
            this.setState({
                venueEquipList: this.props.venueEquipList,
            });
        }
        if (this.props.keyPoolList !== prevState.keyPoolList) {
            this.setState({
                keyPoolList: this.props.keyPoolList,
            });
        }
        if (this.props.staffArrayAll !== prevState.staffArrayAll) {
            this.setState({
                staffArrayAll: this.props.staffArrayAll,
            });
        }
        if (this.props.selectDefaultServicePlanResident !== prevProps.selectDefaultServicePlanResident) {
            this.setState({
                selectDefaultServicePlanResident: this.props.selectDefaultServicePlanResident,
            });
        }
        if (this.props.selectDefaultServicePlanWireless !== prevProps.selectDefaultServicePlanWireless) {
            this.setState({
                selectDefaultServicePlanWireless: this.props.selectDefaultServicePlanWireless,
            });
        }
        if (this.props.selectDefaultServicePlanRoaming !== prevProps.selectDefaultServicePlanRoaming) {
            this.setState({
                selectDefaultServicePlanRoaming: this.props.selectDefaultServicePlanRoaming,
            });
        }
        var servicePlanArray = [];
        if (
            this.props.servicePlans !== prevProps.servicePlans &&
            this.props.servicePlans !== undefined
        ) {
            // Check if we were retrying and now have service plans
            const wasEmpty = !prevProps.servicePlans || 
                           (Array.isArray(prevProps.servicePlans) && prevProps.servicePlans.length === 0) ||
                           (typeof prevProps.servicePlans === 'object' && Object.keys(prevProps.servicePlans).length === 0);
            const isNowPopulated = this.props.servicePlans && 
                                 ((Array.isArray(this.props.servicePlans) && this.props.servicePlans.length > 0) ||
                                  (typeof this.props.servicePlans === 'object' && Object.keys(this.props.servicePlans).length > 0));
            if (wasEmpty && isNowPopulated && this.state.isOnStep3) {
                console.log('Service plans loaded successfully during retry, stopping retry mechanism');
                this.stopServicePlansRetry();
                this.setState({ 
                    isOnStep3: true, // Keep step3 flag since we're still on step 3
                    modalServicePlansLoading: false, // Hide the loading modal
                });
            }
            this.setState({
                servicePlans: this.props.servicePlans,
            });
            let optionTemplateServicePlans = [];
            for (var i = 0; i < this.props.servicePlans.length; i++) {
                optionTemplateServicePlans.push({
                    value: this.props.servicePlans[i]["ServicePlanID"],
                    name: this.props.servicePlans[i]["ServicePlanName"],
                });
            }
            servicePlanArray.push(
                <MDBSelect
                    id="selectServicePlan"
                    className="form-control"
                    getValue={this.handleSelectServicePlan}
                >
                    <MDBSelectInput
                        className="selectInput selectServicePlan"
                        selected="Choose the Service Plan to Add"
                    />
                    <MDBSelectOptions search>
                        {optionTemplateServicePlans}
                    </MDBSelectOptions>
                </MDBSelect>
            );
            this.setState({
                servicePlanForm: servicePlanArray,
                optionTemplateServicePlans: optionTemplateServicePlans,
                loading_prop_serviceplans: false,
                selectDefaultServicePlanResident:
                    this.props.selectDefaultServicePlanResident,
                selectDefaultServicePlanWireless:
                    this.props.selectDefaultServicePlanWireless,
                selectDefaultServicePlanRoaming:
                    this.props.selectDefaultServicePlanRoaming,
            });
        }
    }
    validateEmail = (email) => {
        var mailformat = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        this.setState({
            invalidPhone: undefined,
            userFound: false,
            userFoundWithPhone: false,
        });
        if (!this.state.email.match(mailformat)) {
            this.setState({
                invalidEmail: "Please provide a valid email address",
            });
            $(".emailInput").addClass("is-invalid");
        } else {
            this.setState({ invalidEmail: undefined });
            $(".emailInput").removeClass("is-invalid");
        }
    };
    selectCountry(val) {
        this.setState({ country: val });
    }
    selectRegion(val) {
        this.setState({ region: val });
    }
    getValueOfSelect = (e) => {
        var index = e.target.selectedIndex;
        var optionElement = e.target.childNodes[index];
        this.setState({
            propertyMUTCGroupSecret: optionElement.getAttribute("value"),
        });
        this.setState({ propertyMUTCGroup: optionElement.getAttribute("id") });
    };
    getValueOfSelectCountry = (value) => {
        this.setState({ country: value[0] });
    };
    getValueOfSelectState = (value) => {
        this.setState({ region: value[0] });
    };
    handleSelectGroup = (value) => {
        this.setState({ selectGroup: value });
    };
    handleSelectKeyPool = (value) => {
        this.setState({ selectKeypool: value });
    };
    handleSelectVenueType = (value) => {
        this.setState({ selectedVenueType: value });
    };
    handleSelectTimeZone = (value) => {
        this.setState({ selectTimeZone: value[0] });
    };
    getPropertyManagementGroups = () => {
        this.setState({ loading_prop_groups: true });
        const data = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        axios
            .post(
                "/networkoperatorconsole/venues/listPropertyManagementGroups",
                data,
                {
                    headers: {},
                }
            )
            .then((response) => {
                let optionTemplateGroup = [];
                Object.keys(response.data.PropertyManagementGroups).map(
                    (oneKey, i) => {
                        optionTemplateGroup.push({
                            value: oneKey,
                            name: response.data.PropertyManagementGroups[
                                oneKey
                            ]["PropertyManagementGroupName"],
                        });
                        return true;
                    }
                );
                this.setState({
                    optionTemplateGroup: optionTemplateGroup,
                    loading_prop_groups: false,
                });
            })
            .catch((error) => {
                this.setState({ loading_prop_groups: false });
            });
    };
    getKeyPools = () => {
        const data = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
        };
        axios
            .post("/networkoperatorconsole/keypools/listKeypools", data, {
                headers: {},
            })
            .then((response) => {
                let optionTemplateKeyPools = [];
                Object.keys(response.data.myKeyPoolList).map((oneKey, i) => {
                    optionTemplateKeyPools.push({
                        value: oneKey,
                        name: response.data.myKeyPoolList[oneKey]["ssid"],
                    });
                    return true;
                });
                this.setState({
                    optionTemplateKeyPools: optionTemplateKeyPools,
                    loading_prop_groups: false,
                    allKeypools: response.data.myKeyPoolList
                });
            })
            .catch((error) => {
                console.log(
                    "🚀 ~ file: AddVenue.js:199 ~ AddVenue ~ error",
                    error
                );
            });
    };
    toggleCheckboxValuesendSubscriptionAddedEmail = () => {
        this.setState({
            sendSubscriptionAddedEmail: !this.state.sendSubscriptionAddedEmail,
        });
    };
    toggleCheckboxValuesendSubscriptionEndedEmail = () => {
        this.setState({
            sendSubscriptionEndEmail: !this.state.sendSubscriptionEndEmail,
        });
    };
    toggleCheckboxValueAllowOverlapping = () => {
        this.setState({ allowOverlapping: !this.state.allowOverlapping });
    };
    toggleCheckboxValueDisplayFCCLabel = () => {
        this.setState({
            displayFCCLabel: !this.state.displayFCCLabel,
        });
    };
    submitHandler = (a, event, param) => {
        event.preventDefault();
        $("#selectTimeZone").removeClass("is-invalid");
        $("#selectCountry").removeClass("is-invalid");
        $("#selectState").removeClass("is-invalid");
        $("#selectGroup").removeClass("is-invalid");
        // $("#selectKeypool").removeClass("is-invalid");
        $("#selectVenueType").removeClass("is-invalid");
        event.target.className += " was-validated";
        if (this.state.country === undefined) {
            this.setState({ invalidCountry: "Please provide a valid country" });
            $("#selectCountry").addClass("is-invalid");
        } else {
            this.setState({ invalidCountry: null });
            $("#selectCountry").addClass("is-valid");
        }
        if (this.state.selectTimeZone === undefined) {
            this.setState({
                invalidTimeZone: "Please provide a valid time zone",
            });
            $("#selectTimeZone").addClass("is-invalid");
        } else {
            this.setState({ invalidTimeZone: null });
            $("#selectTimeZone").addClass("is-valid");
        }
        if (this.state.region === undefined) {
            this.setState({
                invalidState: "Please provide a valid state/region",
            });
            $("#selectState").addClass("is-invalid");
        } else {
            this.setState({ invalidState: null });
            $("#selectState").addClass("is-valid");
        }
        // if (this.state.selectGroup === undefined) {
        //     this.setState({
        //         invalidGroup: "Please provide a valid group name",
        //     });
        //     $("#selectGroup").addClass("is-invalid");
        // } else {
        //     $("#selectGroup").addClass("is-valid");
        // }
        // if (this.state.selectKeypool === undefined) {
        //     this.setState({ invalidKeypool: "Please provide a valid KeyPool" });
        //     $("#selectKeypool").addClass("is-invalid");
        // } else {
        //     $("#selectKeypool").addClass("is-valid");
        // }
        // if (this.state.selectedVenueType === undefined) {
        //     this.setState({
        //         invalidVenueType: "Please provide a valid Venue Type",
        //     });
        //     $("#selectVenueType").addClass("is-invalid");
        // } else {
        //     $("#selectVenueType").addClass("is-valid");
        // }
        // if (this.state.email === undefined) {
        //     this.setState({
        //         invalidEmail: "Please provide a valid email address",
        //     });
        // }
        // if (
        //     this.state.invalidPhone === null ||
        //     this.state.invalidPhone !== undefined
        // ) {
        //     this.setState({
        //         invalidPhone: "Please provide a valid phone number",
        //     });
        //     $(".PhoneInput").addClass("is-invalid");
        // } else {
        //     $(".PhoneInput").addClass("is-valid");
        // }
        // if (this.state.email === undefined) {
        //     this.setState({
        //         invalidEmail: "Please provide a valid email address",
        //     });
        // }
        if (
            this.state.venueName !== undefined &&
            // this.state.invalidEmail === undefined &&
            // this.state.invalidPhone === undefined &&
            this.state.address1 !== undefined &&
            this.state.country !== undefined &&
            this.state.city !== undefined &&
            this.state.region !== undefined &&
            this.state.postalcode !== undefined
            // &&
            // this.state.selectGroup !== undefined &&
            // // this.state.selectKeypool !== undefined &&
            // this.state.selectedVenueType !== undefined &&
            // this.state.firstName !== undefined &&
            // this.state.lastName !== undefined
        ) {
            this.props.submitHandler(
                this.state.venueName,
                this.state.email,
                this.state.address1,
                this.state.address2,
                this.state.phoneNumber,
                this.state.country,
                this.state.city,
                this.state.region,
                this.state.postalcode,
                this.state.selectGroup,
                this.state.countdown,
                this.state.durationResident,
                this.state.durationGuest,
                this.state.durationRoaming,
                this.state.firstName,
                this.state.lastName,
                this.state.minVlanRes,
                this.state.maxVlanRes,
                this.state.minVlanGuest,
                this.state.maxVlanGuest,
                this.state.minVlanRoaming,
                this.state.maxVlanRoaming,
                this.state.selectedVenueType,
                this.state.enableShoppingCart,
                this.state.sendSubscriptionAddedEmail,
                this.state.sendSubscriptionEndEmail,
                this.state.allowOverlapping,
                this.state.displayFCCLabel,
                this.state.typicalLatency,
                this.state.externalVenueID
            );
        }
    };
    modifyVenueInfo = (a, event, param) => {
        event.preventDefault();
        event.target.className += " was-validated";
        $("#selectGroup").removeClass("is-invalid");
        if (this.state.selectGroup === undefined) {
            this.setState({
                invalidLanguage: "Please provide a valid group name",
            });
            $("#selectGroup").addClass("is-invalid");
        } else {
            $("#selectGroup").addClass("is-valid");
        }
        $("#selectVenueType").removeClass("is-invalid");
        if (this.state.selectedVenueType === undefined) {
            this.setState({
                invalidLanguage: "Please provide a valid Venue Type",
            });
            $("#selectVenueType").addClass("is-invalid");
        } else {
            $("#selectVenueType").addClass("is-valid");
        }
        // if (this.state.email === undefined) {
        //     this.setState({
        //         invalidEmail: "Please provide a valid email address",
        //     });
        // }
        // if (
        //     this.state.invalidPhone === null ||
        //     this.state.invalidPhone !== undefined
        // ) {
        //     this.setState({
        //         invalidPhone: "Please provide a valid phone number",
        //     });
        //     $(".PhoneInput").addClass("is-invalid");
        // } else {
        //     $(".PhoneInput").addClass("is-valid");
        // }
        if (this.state.venueName !== undefined) {
            this.props.modifyVenueInfo(
                this.state.address1,
                this.state.address2,
                this.state.phoneNumber,
                this.state.country,
                this.state.city,
                this.state.region,
                this.state.postalcode,
                this.state.email,
                this.state.countdown,
                this.state.durationResident,
                this.state.durationGuest,
                this.state.durationRoaming,
                this.state.firstName,
                this.state.lastName,
                this.state.minVlanRes,
                this.state.maxVlanRes,
                this.state.minVlanGuest,
                this.state.maxVlanGuest,
                this.state.minVlanRoaming,
                this.state.maxVlanRoaming,
                this.state.selectedVenueType,
                this.state.enableShoppingCart,
                this.state.sendSubscriptionAddedEmail,
                this.state.sendSubscriptionEndEmail,
                this.state.allowOverlapping,
                this.state.displayFCCLabel,
                this.state.typicalLatency
            );
            this.setState({
                formActivePanel1: this.props.tabNumber,
                formActivePanel1Changed: this.props.tabChanged,
            });
        }
    };
    changeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    changeHandlerPhone = (event) => {
        this.setState({ phoneNumber: event });
        var value = event
            ? isPossiblePhoneNumber(event)
                ? undefined
                : "Please provide a valid phone number"
            : "Phone number required";
        this.setState({ invalidPhone: value });
    };
    createMask = () => {
        this.setState({
            phoneNumber: this.state.phoneNumber.replace(/\D/g, ""),
        });
    };
    toggleCheckboxValueEnable = () => {
        this.setState({
            enableShoppingCart: !this.state.enableShoppingCart,
        });
    };
    startServicePlansRetry = () => {
        // Clear any existing interval
        if (this.state.servicePlansRetryInterval) {
            clearInterval(this.state.servicePlansRetryInterval);
        }
        // Clear any existing timer
        if (this.state.servicePlansTimerInterval) {
            clearInterval(this.state.servicePlansTimerInterval);
        }
        // Reset retry count and start retry mechanism
        this.setState({
            servicePlansRetryCount: 0,
            servicePlansElapsedSeconds: 0,
            isOnStep3: true,
            modalServicePlansLoading: true,
        });
        // Tick elapsed seconds every 1s
        const timerInterval = setInterval(() => {
            this.setState(prev => ({ servicePlansElapsedSeconds: prev.servicePlansElapsedSeconds + 1 }));
        }, 1000);
        this.setState({ servicePlansTimerInterval: timerInterval });
        const retryInterval = setInterval(() => {
            const servicePlans = this.props.servicePlans;
            const isEmpty = !servicePlans || 
                          (Array.isArray(servicePlans) && servicePlans.length === 0) ||
                          (typeof servicePlans === 'object' && Object.keys(servicePlans).length === 0);
            console.log(`Service Plans Retry ${this.state.servicePlansRetryCount + 1}/${this.state.servicePlansMaxRetries}:`, servicePlans);
            console.log('Is still empty:', isEmpty);
            if (!isEmpty) {
                // Service plans are now available, stop retrying
                console.log('Service plans loaded successfully, stopping retry');
                clearInterval(this.state.servicePlansRetryInterval);
                this.setState({
                    servicePlansRetryInterval: null,
                    servicePlansRetryCount: 0,
                    modalServicePlansLoading: false,
                });
            } else if (this.state.servicePlansRetryCount >= this.state.servicePlansMaxRetries) {
                // Max retries reached, stop trying
                console.log('Max retries reached for service plans, stopping retry');
                clearInterval(this.state.servicePlansRetryInterval);
                this.setState({
                    servicePlansRetryInterval: null,
                    servicePlansRetryCount: 0,
                    modalServicePlansLoading: false,
                });
            } else if (this.state.isOnStep3) {
                // Still on step 3 and service plans are empty, retry getVenueDetails
                if (this.props.venueID && this.props.getVenueDetails) {
                    console.log('Retrying getVenueDetails for service plans');
                    this.props.getVenueDetails(this.props.venueID);
                }
                this.setState({
                    servicePlansRetryCount: this.state.servicePlansRetryCount + 1,
                });
            } else {
                // User navigated away from step 3, stop retrying
                console.log('User left step 3, stopping service plans retry');
                clearInterval(this.state.servicePlansRetryInterval);
                this.setState({
                    servicePlansRetryInterval: null,
                    servicePlansRetryCount: 0,
                    modalServicePlansLoading: false,
                });
            }
        }, 3000); // Retry every 3 seconds
        this.setState({
            servicePlansRetryInterval: retryInterval,
        });
    };
    stopServicePlansRetry = () => {
        if (this.state.servicePlansRetryInterval) {
            clearInterval(this.state.servicePlansRetryInterval);
        }
        if (this.state.servicePlansTimerInterval) {
            clearInterval(this.state.servicePlansTimerInterval);
        }
        this.setState({
            servicePlansRetryInterval: null,
            servicePlansTimerInterval: null,
            servicePlansRetryCount: 0,
            servicePlansElapsedSeconds: 0,
            isOnStep3: false,
            modalServicePlansLoading: false,
        });
    };
    toggleServicePlansLoadingModal = () => {
        this.setState({
            modalServicePlansLoading: !this.state.modalServicePlansLoading,
        });
    };
    swapFormActive = (a) => (param) => (e) => {
        // Check if servicePlans is empty or undefined when navigating to Step 3 (Service Plans)
        if (a === 1 && param === 3) {
            const servicePlans = this.props.servicePlans;
            const isEmpty = !servicePlans || 
                          (Array.isArray(servicePlans) && servicePlans.length === 0) ||
                          (typeof servicePlans === 'object' && Object.keys(servicePlans).length === 0);
            console.log('Step 3 Navigation - servicePlans:', servicePlans);
            console.log('Step 3 Navigation - isEmpty:', isEmpty);
            console.log('Step 3 Navigation - venueID:', this.props.venueID);
            if (isEmpty) {
                // Start retry mechanism for service plans
                if (this.props.venueID && this.props.getVenueDetails) {
                    console.log('Starting service plans retry mechanism');
                    this.props.getVenueDetails(this.props.venueID);
                    this.startServicePlansRetry();
                }
            } else {
                // Service plans are available, ensure retry is stopped
                this.setState({ isOnStep3: true });
                this.stopServicePlansRetry();
            }
        } else {
            // Not navigating to step 3, stop retry if it's running
            this.setState({ isOnStep3: false });
            this.stopServicePlansRetry();
        }
        this.setState({
            ["formActivePanel" + a]: param,
            ["formActivePanel" + a + "Changed"]: true,
        });
    };
    handleNextPrevClick = (a) => (param) => (event) => {
        if (a === 1 && param === 2) {
            if (this.props.venueID !== undefined) {
                this.modifyVenueInfo(a, event, param);
            } else {
                this.submitHandler(a, event, param);
            }
        } else if (a === 1 && param === 6) {
            this.handleShoppingCart(a, event, param);
        } else if (a === 1 && param === 8) {
            this.handlePMS(a, event, param);
        } else if (a === 1 && param === 3) {
            // Check if servicePlans is empty or undefined when navigating to Step 3 (Service Plans)
            const servicePlans = this.props.servicePlans;
            const isEmpty = !servicePlans || 
                          (Array.isArray(servicePlans) && servicePlans.length === 0) ||
                          (typeof servicePlans === 'object' && Object.keys(servicePlans).length === 0);
            console.log('Step 3 Navigation (Next) - servicePlans:', servicePlans);
            console.log('Step 3 Navigation (Next) - isEmpty:', isEmpty);
            console.log('Step 3 Navigation (Next) - venueID:', this.props.venueID);
            if (isEmpty) {
                // Start retry mechanism for service plans
                if (this.props.venueID && this.props.getVenueDetails) {
                    console.log('Starting service plans retry mechanism (Next button)');
                    this.props.getVenueDetails(this.props.venueID);
                    this.startServicePlansRetry();
                }
            } else {
                // Service plans are available, ensure retry is stopped
                this.setState({ isOnStep3: true });
                this.stopServicePlansRetry();
            }
            this.setState({
                formActivePanel1: param,
                formActivePanel1Changed: true,
            });
        } else {
            // Not navigating to step 3, stop retry if it's running
            this.setState({ isOnStep3: false });
            this.stopServicePlansRetry();
            this.setState({
                formActivePanel1: param,
                formActivePanel1Changed: true,
            });
        }
    };
    /* Bulk Upload Units */
    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    formatzip(num) {
        var s = "00000" + num;
        return s.substr(s.length - 5);
    }
    convertCSV = async (data) => {
        console.log("CSV Data parsed:", data);
        console.log("First row keys:", data[0] ? Object.keys(data[0]) : "No data");
        
        this.setState({ loading_upload: true });
        this.setState({ modalError: false });
        this.setState({
            unitUnprocessed: undefined,
            buildingUnprocessed: undefined,
            floorUnprocessed: undefined,
            lastProcessed: undefined,
            progress: 0
        });
        let dataImported = [];
        for (let i = 0; i < data.length; i++) {
            // Validate required fields
            const requiredFields = {
                "unit_id_": "Unit ID",
                "building_": "Building",
                "floor_": "Floor",
                "purpose__wiredunit_or_localwirelessonly__": "Purpose",
                "address_1_": "Address 1",
                "city_": "City",
                "state_": "State",
                "country_": "Country",
                "postal_code_": "Postal Code",
                "vlan": "VLAN"
            };
            
            const missingFields = [];
            for (const [field, label] of Object.entries(requiredFields)) {
                const value = data[i][field];
                // Check if value is missing, treating 0 as valid, empty string as invalid
                const isMissing = value === undefined || 
                                 value === null || 
                                 (typeof value === 'string' && value.trim() === "") ||
                                 (typeof value === 'number' && isNaN(value));
                
                if (isMissing) {
                    missingFields.push(label);
                    console.log(`Row ${i + 2}: Missing field '${field}' (${label}), value:`, value);
                }
            }
            
            if (missingFields.length > 0) {
                console.error("Available fields in row:", Object.keys(data[i]));
                console.error("Expected fields:", Object.keys(requiredFields));
                this.setState({
                    unitUnprocessed: data[i]["unit_id_"] || "N/A",
                    buildingUnprocessed: data[i]["building_"] || "N/A",
                    floorUnprocessed: data[i]["floor_"] || "N/A",
                    lastProcessed: i,
                    modalError: true,
                    errorMessage: `Missing required field(s): ${missingFields.join(", ")}. Please ensure you're using the correct Unit Upload template (not Subscriber template) and that all required fields are marked with asterisks (*) in the header row.`,
                    loading_upload: false
                });
                this.cancelUploadedFile();
                return;
            }
            
            if (
                data[i]["shopping_cart_price_adjustment"] !== null &&
                data[i]["shopping_cart_price_adjustment"] !== undefined &&
                data[i]["shopping_cart_price_adjustment"] !== "" &&
                isNaN(Number(data[i]["shopping_cart_price_adjustment"]))
            ) {
                this.setState({ loading_upload: false });
                this.cancelUploadedFile();
                this.toggleError();
                this.setState({
                 unitUnprocessed: data[i]["unit_id_"],
                 buildingUnprocessed: data[i]["building_"],
                 floorUnprocessed: data[i]["floor_"],
                 lastProcessed: i + 1,
             });
                this.setState({
                 modalError: true,
                 errorMessage: "Shopping Cart Price Adjustment on line " +
                        [i + 2] +
                        " must be a valid number, please check your upload file and try again",
             });
                return;
            } else {
            dataImported[i] = {
                VenueID: this.props.venueID,
                UnitID: data[i]["unit_id_"].toString(),
                UnitFloor: data[i]["floor_"].toString(),
                UnitBuilding: data[i]["building_"].toString(),
                AddressLine1: data[i]["address_1_"].toString(),
                AddressLine2:
                    data[i]["address_2"] === null
                        ? ""
                        : data[i]["address_2"].toString(),
                City: data[i]["city_"].toString(),
                State: data[i]["state_"].toString(),
                PostalCode:
                    data[i]["country_"] === "USA"
                        ? this.formatzip(data[i]["postal_code_"])
                        : data[i]["postal_code_"].toString(),
                "Country.ISO3166A3": data[i]["country_"],
                SharedSecret: this.props.sharedSecret,
                AccessToken: sessionStorage.getItem("AccessToken"),
                IdToken: sessionStorage.getItem("IdToken"),
                vlan: data[i]["vlan"].toString(),
                purpose:
                    data[i][
                        "purpose__wiredunit_or_localwirelessonly__"
                    ].toLowerCase(),
                ServicePlanID: data[i]["service_plan_id"],
                UnitID_internal: data[i]["unit_internal_id"] ? data[i]["unit_internal_id"].toString() : "",
                externalVenueUnitID: data[i]["unit_external_id"] ? data[i]["unit_external_id"].toString() : "",
                ShoppingCartPriceAdjustment:
                -Math.abs(data[i]["shopping_cart_price_adjustment"] * 100)
            };
            let unitID = data[i]["unit_id_"];
            let building = data[i]["building_"];
            let floor = data[i]["floor_"];
            await axios
                .post(
                    "/networkoperatorconsole/venues/addVenueUnits",
                    dataImported[i],
                    {
                        headers: {},
                    }
                )
                .then(
                    (response) => {
                        toast.success(
                            "Unit " +
                                unitID +
                                ", Building " +
                                building +
                                ", Floor " +
                                floor +
                                " processed",
                            {
                                closeButton: false,
                            }
                        );
                        if (i + 1 === data.length) {
                            this.props.updateName(
                                this.props.venueName,
                                this.props.venueID
                            );
                        }
                    },
                    (error) => {
                        this.setState({
                            unitUnprocessed: unitID,
                            buildingUnprocessed: building,
                            floorUnprocessed: floor,
                            lastProcessed: i + 1,
                        });
                        this.cancelUploadedFile();
                        i = data.length;
                        this.setState({
                         modalError: true,
                         errorMessage: error.response.data.message,
                     });
                    }
                );
            this.setState({ progress: ((i + 1) / data.length) * 100 });
          }
        }
        this.setState({ loading_upload: false });
    };
    cancelUploadedFile() {
        const randomString = Math.random().toString(36);
        this.setState({
            theInputKey: randomString,
        });
    }
    convertToCSV(objArray) {
        var array =
            typeof objArray != "object" ? JSON.parse(objArray) : objArray;
        var str = "";
        for (var i = 0; i < array.length; i++) {
            var line = "";
            for (var index in array[i]) {
                if (line !== "") line += ",";
                line += '"' + array[i][index] + '"';
            }
            str += line + "\r\n";
        }
        return str;
    }
    exportCSVFile(headersExport, items, fileTitle) {
        if (headersExport !== items[0]) {
            items.unshift(headersExport);
        }
        // Convert Object to JSON
        var jsonObject = JSON.stringify(items);
        var csv = this.convertToCSV(jsonObject);
        var exportedFilename = "Unit_Upload_Template.csv";
        var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        if (navigator.msSaveBlob) {
            // IE 10+
            navigator.msSaveBlob(blob, exportedFilename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) {
                // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", exportedFilename);
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    /*Service Plan Section*/
    toggleAddServicePlan = () => {
        this.setState({
            modalAddServicePlan: !this.state.modalAddServicePlan,
        });
    };
    toggleAddServicePlanToVenue = () => {
        this.setState({
            modalAddServicePlanToVenue: !this.state.modalAddServicePlanToVenue,
        });
    };
    handleSelectDefaultServicePlanResident = (value) => {
        this.setState({
            selectGroup: value,
            loading: true,
        });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
            DefaultServicePlanID_GlobalWirelessPlusLocalWiredAccess: value,
        };
        axios
            .post("/networkoperatorconsole/venues/configureVenue", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success(
                        "Default Service Plan for Residential Unit Set!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({ loading: false });
                    this.props.getVenueDetails(this.props.venueID);
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                }
            );
    };
    handleSelectDefaultServicePlanWireless = (value) => {
        this.setState({
            selectGroup: value,
            loading: true,
        });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
            DefaultServicePlanID_LocalWirelessAccess: value,
        };
        axios
            .post("/networkoperatorconsole/venues/configureVenue", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success(
                        "Default Service Plan for Guest Subscription Set!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({ loading: false });
                    this.props.getVenueDetails(this.props.venueID);
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                }
            );
    };
    handleSelectDefaultServicePlanRoaming = (value) => {
        this.setState({
            selectGroup: value,
            loading: true,
        });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
            DefaultServicePlanID_Roaming: value,
        };
        axios
            .post("/networkoperatorconsole/venues/configureVenue", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success(
                        "Default Service Plan for Roaming Subscription Set!",
                        {
                            closeButton: false,
                        }
                    );
                    this.setState({ loading: false });
                    this.props.getVenueDetails(this.props.venueID);
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                }
            );
    };
    submitAddServicePlan = async (
        servicePlanName,
        servicePlanDescription,
        uploadKbps,
        downloadKbps,
        conDevices,
        sessionTimeout,
        maxRecurrance,
        maxTrialCycles,
        billingCycleHours,
        billingCyclePrice,
        billingCycleRecurrence,
        trialcycles,
        spimage,
        globallyavailable,
        externalServicePlanID,
        smsCode,
        unique_plan_id,
        typical_download_speed,
        typical_upload_speed,
        privacy_policy_url,
        network_management_policy_url,
        data_allowance_policy_url,
        bundle_discounts_url,
        customer_service_url
    ) => {
        this.setState({ add_serviceplan: true });
        const firstCurrencyValue = JSON.parse(sessionStorage.getItem("currencyNames"))[0];
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            ServicePlanName: servicePlanName,
            ServicePlanDescription: servicePlanDescription,
            UploadKbps: uploadKbps,
            DownloadKbps: downloadKbps,
            ConcurrentDevices: conDevices,
            SessionTimeoutSecondsPerDevice: sessionTimeout,
            MaximumTrialCyclesPerSubscriberPerVenue: maxTrialCycles,
            MaximumFreeEnrollmentsPerSubscriberPerVenue: maxRecurrance,
            BillingCycleHours: billingCycleHours,
            ["BillingCyclePrice." + firstCurrencyValue]:
                billingCyclePrice === undefined ? 0 : billingCyclePrice * 100,
            BillingCycleRecurrence: billingCycleRecurrence,
            ServicePlanImageURL: spimage,
            GloballyAvailablePlan: globallyavailable,
            TrialCycles: trialcycles === undefined ? 0 : trialcycles,
            externalServicePlanID: externalServicePlanID,
            SMSCode: smsCode,
            FCCLabel: {
                PlanID: unique_plan_id,
                TypicalUploadKbps: typical_upload_speed,
                TypicalDownloadKbps: typical_download_speed,
                PrivacyPolicyURL: privacy_policy_url,
                NetworkMgmtPolicyURL: network_management_policy_url,
                DataPolicyURL: data_allowance_policy_url,
                BundleDiscountURL: bundle_discounts_url,
                SupportURL: customer_service_url,
            },
        };
        await axios
            .post("/networkoperatorconsole/equipment/addServicePlan", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Service Plan!", {
                        closeButton: false,
                    });
                    this.toggleAddServicePlan();
                    this.setState({ add_serviceplan: false });
                    this.submitAddServicePlanToVenue(
                        response.data.ServicePlanID,
                        true
                    );
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.toggleAddServicePlan();
                    this.setState({ add_serviceplan: false });
                }
            );
    };
    submitAddServicePlanToVenue = (servicePlanID, newServicePlan) => {
        this.setState({ add_serviceplan: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
            SharedSecret: this.props.sharedSecret,
            ServicePlanID: servicePlanID,
        };
        axios
            .post("/networkoperatorconsole/venues/enableServicePlan", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Service Plan to Venue!", {
                        closeButton: false,
                    });
                    if (newServicePlan !== true) {
                        this.toggleAddServicePlanToVenue();
                    }
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({ add_serviceplan: false });
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.toggleAddServicePlan();
                    this.setState({ add_serviceplan: false });
                }
            );
    };
    toggleConfirmDisablePlan = (key) => {
        this.setState({
            modalConfirmDisablePlan: !this.state.modalConfirmDisablePlan,
        });
    };
    disablePlanConfirm = (key) => {
        this.toggleConfirmDisablePlan();
        this.setState({
            toggleConfirmDisablePlan: true,
            modal: !this.state.modal,
            servicePlanID: this.props.servicePlans[key]["ServicePlanID"],
            servicePlanName: this.props.servicePlans[key]["ServicePlanName"],
        });
    };
    disablePlan = () => {
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            SharedSecret: this.props.sharedSecret,
            VenueID: this.props.venueID,
            ServicePlanID: this.state.servicePlanID,
        };
        this.setState({ disable_serviceplan: true });
        axios
            .post("/networkoperatorconsole/venues/disableServicePlan", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Service Plan Disabled!", {
                        closeButton: false,
                    });
                    this.props.getVenueDetails(this.props.venueID);
                    this.toggleConfirmDisablePlan();
                    this.setState({ disable_serviceplan: false });
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.toggleConfirmDisablePlan();
                    this.setState({ disable_serviceplan: false });
                }
            );
    };
    /* Venue Equipment */
    toggleAddVenueEquipment = () => {
        this.setState({
            modalAddVenueEquipment: !this.state.modalAddVenueEquipment,
        });
    };
    submitAddVenueEquipment = (
        equipID,
        manufacturer,
        model,
        type,
        zone,
        protocol,
        ipaddy,
        port,
        userName,
        userPassword,
        status,
        pre643
    ) => {
        this.setState({ add_venueequip: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
            EquipmentID: equipID,
            Manufacturer: manufacturer,
            Model: model,
            EquipmentType: type,
            WirelessZone: zone,
            ConnectionProtocol: protocol,
            IPAddress: ipaddy,
            Port: port,
            Username: userName,
            Password: userPassword,
            Status: status,
            MikrotikPre643: pre643,
        };
        axios
            .post("/networkoperatorconsole/venues/addVenueEquipment", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Equipment to Venue!", {
                        closeButton: false,
                    });
                    this.toggleAddVenueEquipment();
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({ add_venueequip: false });
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.toggleAddVenueEquipment();
                    this.setState({ add_venueequip: false });
                }
            );
    };
    toggleModifyEquipment = () => {
        this.setState({
            modalModifyEquipment: !this.state.modalModifyEquipment,
        });
    };
    modifyEquipment = (key) => {
        this.setState({
            modalModifyEquipment: !this.state.modalModifyEquipment,
            equipID: key,
        });
    };
    submitModifyEquipment = (
        equipName,
        manufacturer,
        model,
        type,
        zone,
        protocol,
        ipaddy,
        port,
        userName,
        userPassword,
        status,
        pre643
    ) => {
        this.setState({ modify_equipment: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            SharedSecret: this.props.sharedSecret,
            VenueID: this.props.venueID,
            EquipmentID: this.state.equipID,
            Manufacturer: manufacturer,
            Model: model,
            EquipmentType: type,
            WirelessZone: zone,
            ConnectionProtocol: protocol,
            IPAddress: ipaddy,
            Port: port,
            Username: userName,
            Password: userPassword,
            Status: status,
            MikrotikPre643: pre643,
        };
        axios
            .post("/networkoperatorconsole/venues/updateVenueEquipment", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Updated Equipment!", {
                        closeButton: false,
                    });
                    this.toggleModifyEquipment();
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({ modify_equipment: false });
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.toggleModifyEquipment();
                    this.setState({ modify_equipment: false });
                }
            );
    };
    /* Shopping Cart */
    toggleCheckboxValueEnableShoppingCart = () => {
        this.setState({
            enableShoppingCart: !this.state.enableShoppingCart,
        });
    };
    handleSelectTrialCycles = (value) => {
        this.setState({ selectedTrialCycles: value });
    };
    handleShoppingCart = (a, event, param) => {
        event.preventDefault();
        this.setState({
            loading: true,
        });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            enableShoppingCart: this.state.enableShoppingCart,
            ShoppingCartPriceAdjustment:
                -Math.abs(this.state.shoppingCartPriceAdjustment) * 100,
            TrialCycleAdjustment: this.state.selectedTrialCycles,
            VenueID: this.props.venueID,
            StripePublishableKey: this.state.stripePublishableKey,
            Stripe_Secret_key: this.state.stripeSecretKey,
            Stripe_Webhook_signingsecret: this.state.stripeWebhookSigningSecret,
        };
        axios
            .post("/networkoperatorconsole/venues/configureVenue", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Updated Shopping Cart for Venue!", {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({
                        formActivePanel1: 6,
                        formActivePanel1Changed: this.props.tabChanged,
                    });
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                }
            );
    };
    /* Keypools */
    toggleAddKeypool = () => {
        this.setState({
            modalAddKeypool: !this.state.modalAddKeypool,
        });
    };
    submitAddKeypool = (ssid, venueID, scope, displayOrder) => {
        this.setState({ add_keypool: true });
        let body;
         if (scope === "global") {
        body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            SSID: ssid,
            Scope: scope
        };
    }else{
        body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            SSID: ssid,
            VenueID: this.props.venueID,
        };
    }
        axios
            .post("/networkoperatorconsole/keypools/addKeypool", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Keypool to Venue!", {
                        closeButton: false,
                    });
                    this.toggleAddKeypool();
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({ add_keypool: false });
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.toggleAddKeypool();
                    this.setState({ add_keypool: false });
                }
            );
    };
    submitAssignKeypool = (keypoolID, venueID, ssid) => {
        this.setState({ add_keypool: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            KeyPoolID: keypoolID,
            connectVenueID: this.props.venueID,
        };

        axios
            .post("/networkoperatorconsole/keypools/configureKeypool", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Keypool assigned successfully!", {
                        closeButton: false,
                    });
                    this.toggleAddKeypool();
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({ add_keypool: false });
                },
                (error) => {
                    toast.error(error?.response?.data?.message || "There was an error!", {
                        closeButton: false,
                    });
                    this.toggleAddKeypool();
                    this.setState({ add_keypool: false });
                }
            );
    };
    /* PMS */
    // PMS Profile Selection Methods
    handleSelectPMSProfile = (selectedProfileId) => {
        console.log("handleSelectPMSProfile called with ID:", selectedProfileId);
        
        // If single space is selected, it means "No PMS"
        const isUnlinking = selectedProfileId === " " || selectedProfileId === null;
        
        this.setState({
            selectedPMSProfile: isUnlinking ? " " : selectedProfileId,
            selectedPMSProfileInfo: isUnlinking ? null : this.state.pmsProfileOptions.find(p => p.value === selectedProfileId),
            // Clear venue-specific PMS fields when unlinking
            ...(isUnlinking && {
                realpageSiteId: " ",
                entrataPropertyId: " ",
                PMSEnableUnitSync: false,
                PMSEnableSubscriberSync: false,
                PMSBlacklistedEmails: [],
                PMSBlacklistedEmailInput: ""
            })
        });
    };

    fetchPMSProfiles = async () => {
        this.setState({
            loading_pms_profiles: true,
        });
        
        // Initialize with "No PMS" option
        const pmsProfileOptions = [{
            value: " ",
            name: "No PMS",
            Type: null,
            ProfileName: "No PMS"
        }];
        
        const data = {
            AccessToken: sessionStorage.getItem("AccessToken"),
        };
        
        return axios
            .post("/operatorconsole/config/listPMSProfiles", data)
            .then((response) => {
                if (response.data && response.data.PMSProfiles) {
                    response.data.PMSProfiles.map((profile, i) => {
                        pmsProfileOptions.push({
                            // Dropdown properties
                            value: profile.ProfileID,
                            name: profile.ProfileName,
                            // Original API properties (with duplicates for backward compatibility)
                            ...profile,
                        });
                        return true;
                    });
                }
                console.log("Fetched PMS Profiles:", pmsProfileOptions);
                
                this.setState({
                    pmsProfileOptions: pmsProfileOptions,
                    loading_pms_profiles: false,
                });
            })
            .catch((error) => {
                console.error("Error fetching PMS profiles:", error);
                // Even on error, provide the "No PMS" option (already initialized above)
                this.setState({ 
                    pmsProfileOptions: pmsProfileOptions,
                    loading_pms_profiles: false 
                });
            });
    };

    changeHandlerUnitSync = () => {
        // Only allow toggling if subscriber sync is not enabled
        if (!this.state.PMSEnableSubscriberSync) {
            this.setState({
                PMSEnableUnitSync: !this.state.PMSEnableUnitSync,
            });
        }
    };

    changeHandlerSubscriberSync = () => {
        const newSubscriberSyncValue = !this.state.PMSEnableSubscriberSync;
        this.setState({
            PMSEnableSubscriberSync: newSubscriberSyncValue,
            // Auto-enable unit sync when subscriber sync is enabled
            PMSEnableUnitSync: newSubscriberSyncValue ? true : this.state.PMSEnableUnitSync,
        });
    };

    handleAddBlacklistedEmail = (event) => {
        if (event.key && event.key !== "Enter") {
            return;
        }
        event.preventDefault();
        const email = this.state.PMSBlacklistedEmailInput.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (emailRegex.test(email)) {
            if (!this.state.PMSBlacklistedEmails.includes(email)) {
                this.setState({
                    PMSBlacklistedEmails: [...this.state.PMSBlacklistedEmails, email],
                    PMSBlacklistedEmailInput: ""
                });
            } else {
                alert('Email already added');
            }
        } else {
            alert('Please enter a valid email address');
        }
    };

    handleRemoveBlacklistedEmail = (emailToRemove) => {
        this.setState({
            PMSBlacklistedEmails: this.state.PMSBlacklistedEmails.filter(email => email !== emailToRemove)
        });
    };

    handleBlacklistedEmailInput = (event) => {
        this.setState({ PMSBlacklistedEmailInput: event.target.value });
    };

    handlePMS = (a, event, param) => {
        event.preventDefault();
        
        // Get the form element
        const form = event.currentTarget.closest('form') || event.target.closest('form');
        
        // Additional validation for PMS-specific fields
        let hasValidationError = false;
        if (this.state.selectedPMSProfile && this.state.selectedPMSProfile !== " ") {
            const pmsType = this.state.selectedPMSProfileInfo?.Type?.toLowerCase();
            
            if (pmsType === 'entrata' && (!this.state.entrataPropertyId || this.state.entrataPropertyId.trim() === '')) {
                hasValidationError = true;
                // Add is-invalid class to the input
                const entrataInput = document.querySelector('input[name="entrataPropertyId"]');
                if (entrataInput) {
                    entrataInput.classList.add('is-invalid');
                }
            } else {
                // Remove is-invalid class if validation passes
                const entrataInput = document.querySelector('input[name="entrataPropertyId"]');
                if (entrataInput) {
                    entrataInput.classList.remove('is-invalid');
                }
            }
            
            if (pmsType === 'realpage' && (!this.state.realpageSiteId || this.state.realpageSiteId.trim() === '')) {
                hasValidationError = true;
                // Add is-invalid class to the input
                const realpageInput = document.querySelector('input[name="realpageSiteId"]');
                if (realpageInput) {
                    realpageInput.classList.add('is-invalid');
                }
            } else {
                // Remove is-invalid class if validation passes
                const realpageInput = document.querySelector('input[name="realpageSiteId"]');
                if (realpageInput) {
                    realpageInput.classList.remove('is-invalid');
                }
            }
        }
        
        // If there's a validation error, add validation class and stop
        if (hasValidationError) {
            if (form) {
                form.classList.add('was-validated');
            }
            return;
        }
        
        this.setState({
            loading: true,
        });
        
        const pms = {
            enableUnitSync: this.state.PMSEnableUnitSync,
            enableSubscriberSync: this.state.PMSEnableSubscriberSync
        };
        
        // Add blacklisted subscriber emails
        if (this.state.PMSBlacklistedEmails && this.state.PMSBlacklistedEmails.length > 0) {
            pms.blacklistedSubscriberEmails = this.state.PMSBlacklistedEmails.join(",");
        }
        
        // Include ProfileID if selected
        if (this.state.selectedPMSProfile) {
            pms.ProfileID = this.state.selectedPMSProfile;
        }
        
        // Check if unlinking (ProfileID is single space)
        const isUnlinking = this.state.selectedPMSProfile === " ";
        
        if (isUnlinking) {
            // When unlinking, send empty venue-specific configuration to clear it
            pms.RealPage = {
                RealPageSiteId: " "
            };
            pms.Entrata = {
                EntrataPropertyId: " "
            };
        } else {
            // When linking, only include venue-specific configuration if present
            if (this.state.realpageSiteId) {
                pms.RealPage = {
                    RealPageSiteId: this.state.realpageSiteId
                };
            }
            
            if (this.state.entrataPropertyId) {
                pms.Entrata = {
                    EntrataPropertyId: this.state.entrataPropertyId
                };
            }
        }
        
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
            PMS: pms,
            RealPageSiteId: this.state.realpageSiteId,
            EntrataPropertyId: this.state.entrataPropertyId
        };
        axios
            .post("/networkoperatorconsole/venues/configureVenue", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Updated PMS Settings for Venue!", {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({
                        formActivePanel1: 8,
                        formActivePanel1Changed: this.props.tabChanged,
                    });
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.setState({ loading: false });
                }
            );
    };
    /* Administration */
    toggleAddVenueAdministrators = () => {
        this.setState({
            modalAddVenueAdministrators:
                !this.state.modalAddVenueAdministrators,
        });
    };
    submitAddVenueAdministrators = (
        email,
        firstName,
        lastName,
        phoneNumber,
        language,
        contactpref_email,
        contactpref_sms,
        role,
        venueid
    ) => {
        this.setState({ add_venueadmin: true });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            SharedSecret: this.props.sharedSecret,
            VenueID: this.props.venueID,
            EmailAddress: email,
            Role: role,
            GivenName: firstName,
            FamilyName: lastName,
            "PhoneNumber.E164": phoneNumber,
            locale: language,
            contactpref_sms: contactpref_email,
            contactpref_voice: contactpref_sms,
        };
        axios
            .post("/networkoperatorconsole/venues/enableStaffAccess", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Added Administrator to Venue!", {
                        closeButton: false,
                    });
                    this.toggleAddVenueAdministrators();
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                    this.setState({ add_venueadmin: false });
                },
                (error) => {
                    toast.error(error.response.data.message, {
                        closeButton: false,
                    });
                    this.toggleAddVenueAdministrators();
                    this.setState({ add_venueadmin: false });
                }
            );
    };
    toggleConfirmDisable = (key) => {
        this.setState({
            toggleConfirm: true,
            modal: !this.state.modal,
            confirmEmail: key[0],
        });
    };
    toggleDisable = (email) => {
        this.setState({ staffArrayAll: undefined });
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            VenueID: this.props.venueID,
            EmailAddress: email,
        };
        axios
            .post("/networkoperatorconsole/venues/disableStaffAccess", body, {
                headers: {},
            })
            .then(
                (response) => {
                    toast.success("Deleted Administrator", {
                        closeButton: false,
                    });
                    this.setState({
                        modal: !this.state.modal,
                    });
                    this.props.updateName(
                        this.props.venueName,
                        this.props.venueID
                    );
                    this.props.getVenueDetails(this.props.venueID);
                },
                (error) => {
                    toast.error("There was an error!", {
                        closeButton: false,
                    });
                }
            );
    };
    toggle = () => {
        this.setState({
            modal: !this.state.modal,
        });
    };
    toggleError = () => {
        this.setState({
            modalError: !this.state.modalError,
        });
    };
    render() {
        console.log(this.state)
        const { country, region } = this.state;
        const { t } = this.props;
        const venueAdded = !!(this.props.addedVenue || this.props.isVenueCreationComplete);
        const FORMAT = "MM/dd/yyyy";
        var headers = {
            unitID: "Unit ID*",
            unitBuilding: "Building*",
            unitFloor: "Floor*",
            purpose: "Purpose (wiredunit or localwirelessonly)*",
            AddressLine1: "Address 1*",
            SubscriberAddress2: "Address 2",
            SubscriberCity: "City*",
            SubscriberState: "State*",
            SubscriberPostalCode: "Postal Code*",
            SubscriberCountry: "Country*",
            VLAN: "VLAN",
            // ServicePlanID: "Service Plan ID",
            unitIDInternal: "Unit Internal ID",
            externalVenueUnitID: "Unit External ID",
            ShoppingCartPriceAdjustment: "Shopping Cart Price Adjustment",
        };
        var itemsFormatted = [];
        var fileTitle = sessionStorage.getItem("venueName"); // or 'my-unique-title'
        return (
            <>
                {/* {this.props.loading === true ? (
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayMessage">
                            <div
                                className="spinner-border spinner-border"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )} */}
                <MDBModal
                    isOpen={this.state.modalConfirmDisablePlan}
                    toggle={this.toggleConfirmDisablePlan}
                >
                    <MDBModalHeader toggle={this.toggleConfirmDisablePlan}>
                        Confirm Service Plan Disable
                    </MDBModalHeader>
                    <MDBModalBody>
                        <p>Service Plan Name: {this.state.servicePlanName}</p>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn color="primary" onClick={this.disablePlan}>
                            Confirm
                        </MDBBtn>
                        <MDBBtn
                            color="primary"
                            onClick={this.toggleConfirmDisablePlan}
                        >
                            Close
                        </MDBBtn>
                    </MDBModalFooter>
                </MDBModal>
                <MDBModalHeader toggle={this.props.toggleAddNewVenue}>
                    <h4>Add New Venue</h4>
                    <p>{t("addnewresident.required")}</p>
                </MDBModalHeader>
                <MDBModalBody>
                    <MDBStepper form>
                        <MDBStep
                            form
                            className={
                                this.state.formActivePanel1 === 1
                                    ? "stepActive"
                                    : ""
                            }
                        >
                            <a
                                href="#formstep1"
                                onClick={this.swapFormActive(1)(1)}
                            >
                                <MDBBtn
                                    color={
                                        this.state.formActivePanel1 === 1
                                            ? "indigo"
                                            : "white"
                                    }
                                    circle
                                >
                                    <div className="fa">1</div>
                                </MDBBtn>
                                <p>
                                    General
                                    <br /> Information
                                </p>
                            </a>
                        </MDBStep>
                        <MDBStep
                            form
                            className={
                                this.state.formActivePanel1 === 2
                                    ? "stepActive"
                                    : ""
                            }
                        >
                            {venueAdded ? (
                                <a
                                    href="#formstep1"
                                    onClick={this.swapFormActive(1)(2)}
                                >
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 2
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                        disabled={true}
                                    >
                                        <div className="fa">2</div>
                                    </MDBBtn>
                                    <p>
                                        Upload
                                        <br /> Units
                                    </p>
                                </a>
                            ) : (
                                <>
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 2
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                        disabled={true}
                                    >
                                        <div className="fa">2</div>
                                    </MDBBtn>
                                    <p>
                                        Upload
                                        <br /> Units
                                    </p>
                                </>
                            )}
                        </MDBStep>
                        <MDBStep
                            form
                            className={
                                this.state.formActivePanel1 === 3
                                    ? "stepActive disabled"
                                    : ""
                            }
                        >
                            {venueAdded ? (
                                <a
                                    href="#formstep1"
                                    onClick={this.swapFormActive(1)(3)}
                                >
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 3
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                    >
                                        <div className="fa">3</div>
                                    </MDBBtn>
                                    <p>
                                        Service
                                        <br /> Plans
                                    </p>
                                </a>
                            ) : (
                                <>
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 3
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                        disabled={true}
                                    >
                                        <div className="fa">3</div>
                                    </MDBBtn>
                                    <p>
                                        Service
                                        <br /> Plans
                                    </p>
                                </>
                            )}
                        </MDBStep>
                        <MDBStep
                            form
                            className={
                                this.state.formActivePanel1 === 4
                                    ? "stepActive disabled"
                                    : ""
                            }
                        >
                            {venueAdded ? (
                                <a
                                    href="#formstep1"
                                    onClick={this.swapFormActive(1)(4)}
                                >
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 4
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                    >
                                        <div className="fa">4</div>
                                    </MDBBtn>
                                    <p>Equipment</p>
                                </a>
                            ) : (
                                <>
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 4
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                        disabled={true}
                                    >
                                        <div className="fa">4</div>
                                    </MDBBtn>
                                    <p>Equipment</p>
                                </>
                            )}
                        </MDBStep>
                        <MDBStep
                            form
                            className={
                                this.state.formActivePanel1 === 5
                                    ? "stepActive disabled"
                                    : ""
                            }
                        >
                            {venueAdded ? (
                                <a
                                    href="#formstep1"
                                    onClick={this.swapFormActive(1)(5)}
                                >
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 5
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                    >
                                        <div className="fa">5</div>
                                    </MDBBtn>
                                    <p>
                                        Shopping
                                        <br /> Cart
                                    </p>
                                </a>
                            ) : (
                                <>
                                    <>
                                        <MDBBtn
                                            color={
                                                this.state.formActivePanel1 ===
                                                5
                                                    ? "indigo"
                                                    : "white"
                                            }
                                            circle
                                            disabled={true}
                                        >
                                            <div className="fa">5</div>
                                        </MDBBtn>
                                        <p>
                                            Shopping
                                            <br /> Cart
                                        </p>
                                    </>
                                </>
                            )}
                        </MDBStep>
                        <MDBStep
                            form
                            className={
                                this.state.formActivePanel1 === 6
                                    ? "stepActive disabled"
                                    : ""
                            }
                        >
                            {venueAdded ? (
                                <a
                                    href="#formstep1"
                                    onClick={this.swapFormActive(1)(6)}
                                >
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 6
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                    >
                                        <div className="fa">6</div>
                                    </MDBBtn>
                                    <p>Keypools</p>
                                </a>
                            ) : (
                                <>
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 6
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                        disabled={true}
                                    >
                                        <div className="fa">6</div>
                                    </MDBBtn>
                                    <p>Keypools</p>
                                </>
                            )}
                        </MDBStep>
                        <MDBStep
                            form
                            className={
                                this.state.formActivePanel1 === 7
                                    ? "stepActive disabled"
                                    : ""
                            }
                        >
                            {venueAdded ? (
                                <a
                                    href="#formstep1"
                                    onClick={this.swapFormActive(1)(7)}
                                >
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 7
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                    >
                                        <div className="fa">7</div>
                                    </MDBBtn>
                                    <p>PMS</p>
                                </a>
                            ) : (
                                <>
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 7
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                        disabled={true}
                                    >
                                        <div className="fa">7</div>
                                    </MDBBtn>
                                    <p>PMS</p>
                                </>
                            )}
                        </MDBStep>
                        <MDBStep
                            form
                            className={
                                this.state.formActivePanel1 === 8
                                    ? "stepActive disabled"
                                    : ""
                            }
                        >
                            {venueAdded ? (
                                <a
                                    href="#formstep1"
                                    onClick={this.swapFormActive(1)(8)}
                                >
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 8
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                    >
                                        <div className="fa">8</div>
                                    </MDBBtn>
                                    <p>Administration</p>
                                </a>
                            ) : (
                                <>
                                    <MDBBtn
                                        color={
                                            this.state.formActivePanel1 === 8
                                                ? "indigo"
                                                : "white"
                                        }
                                        circle
                                        disabled={true}
                                    >
                                        <div className="fa">8</div>
                                    </MDBBtn>
                                    <p>Administration</p>
                                </>
                            )}
                        </MDBStep>
                    </MDBStepper>
                    {this.props.toggleConfirmContinueOpen ? (
                        <MDBModal
                            isOpen={this.props.modal}
                            toggle={this.toggle}
                        >
                            <MDBModalHeader toggle={this.toggle}>
                                Venue Created
                            </MDBModalHeader>
                            <MDBModalBody>
                                <p>
                                    The Venue has been created. You may continue
                                    through the Wizard, or click cancel and use
                                    the Venue Management options for the
                                    remaining configuration later
                                </p>
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn
                                    color="primary"
                                    type="submit"
                                    onClick={this.props.toggleConfirmContinue}
                                >
                                    Continue
                                </MDBBtn>
                                <MDBBtn
                                    color="primary"
                                    onClick={this.props.toggleAddNewVenue}
                                >
                                    Close
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModal>
                    ) : null}
                    {this.state.formActivePanel1 === 1 && (
                        <form
                            className="needs-validation"
                            onSubmit={this.handleNextPrevClick(1)(2)}
                            noValidate
                        >
                            <h5 className="font-weight-bold pl-0 my-4">
                                <strong>General Information</strong>
                            </h5>
                            <MDBRow>
                                <MDBCol col="6" sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Venue Name*
                                    </label>
                                    <input
                                        required
                                        name="venueName"
                                        id="venueName"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.venueName}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid name
                                    </div>
                                </MDBCol>
                                <MDBCol col="6" sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Property Management Group
                                    </label>
                                    <SelectSearch
                                        id="selectGroup"
                                        search={true}
                                        filterOptions={fuzzySearch}
                                        options={this.state.optionTemplateGroup}
                                        isOptionSelected={true}
                                        inputId="groupArray"
                                        classNamePrefix="group-select"
                                        placeholder="Select..."
                                        onChange={this.handleSelectGroup}
                                        value={this.state.selectGroup}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a Property Management
                                        Group
                                    </div>
                                </MDBCol>
                                {/* <MDBCol col="6" sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Venue Type*
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            - Wi-Fi and Wired Access – Select if
                                            users have Wi-Fi access as well as
                                            wired access
                                            <br />- Wired Only Access – Select
                                            if there is no Managed Wi-Fi access.
                                            E.g. Bring your own Device/CPE’
                                        </span>
                                    </MDBTooltip>
                                    <SelectSearch
                                        id="selectVenueType"
                                        search={true}
                                        filterOptions={fuzzySearch}
                                        options={this.state.venueTypeOptions}
                                        inputId="venueTypeArray"
                                        classNamePrefix="unit-select form-control"
                                        placeholder="Select..."
                                        onChange={this.handleSelectVenueType}
                                        value={this.state.selectedVenueType}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a Venue Type
                                    </div>
                                </MDBCol> */}
                            </MDBRow>
                            <MDBRow>
                                {/* <MDBCol col="6" sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Property Management Group
                                    </label>
                                    <SelectSearch
                                        id="selectGroup"
                                        search={true}
                                        filterOptions={fuzzySearch}
                                        options={this.state.optionTemplateGroup}
                                        isOptionSelected={true}
                                        inputId="groupArray"
                                        classNamePrefix="group-select"
                                        placeholder="Select..."
                                        onChange={this.handleSelectGroup}
                                        value={this.state.selectGroup}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a Property Management
                                        Group
                                    </div>
                                </MDBCol> */}
                                {/* <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        KeyPool*
                                    </label>
                                    <SelectSearch
                                        id="selectKeypool"
                                        search={true}
                                        filterOptions={fuzzySearch}
                                        options={this.state.optionTemplateKeyPools}
                                        isOptionSelected={true}
                                        inputId="keypoolArray"
                                        classNamePrefix="group-select"
                                        placeholder="Select..."
                                        onChange={this.handleSelectKeyPool}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a KeyPool
                                    </div>
                                </MDBCol> */}
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Address Line 1*
                                    </label>
                                    <input
                                        required
                                        name="address1"
                                        id="address1"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.address1}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid address
                                    </div>
                                </MDBCol>
                                <MDBCol sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Address Line 2
                                    </label>
                                    <input
                                        className="form-control"
                                        name="address2"
                                        id="address2"
                                        onChange={this.changeHandler}
                                        value={this.state.address2}
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="12" lg="12">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Country*
                                    </label>
                                    <div className="select-box">
                                        <CountryDropdown
                                            value={country}
                                            onChange={(val) =>
                                                this.selectCountry(val)
                                            }
                                            priorityOptions={[
                                                "CAN",
                                                "USA",
                                                "GBR",
                                            ]}
                                            valueType="short"
                                            countryvaluetype="short"
                                            className="form-control"
                                            id="selectCountry"
                                        />
                                    </div>
                                    {this.state.invalidCountry !== null ? (
                                        <div className="invalid">
                                            {this.state.invalidCountry}
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="12" lg="4">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        City*
                                    </label>
                                    <input
                                        required
                                        name="city"
                                        id="city"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.city}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid city
                                    </div>
                                </MDBCol>
                                <MDBCol sm="12" lg="4">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        State*
                                    </label>
                                    <div className="select-box">
                                        <RegionDropdown
                                            country={country}
                                            value={region}
                                            onChange={(val) =>
                                                this.selectRegion(val)
                                            }
                                            valueType="short"
                                            className="form-control"
                                            id="selectState"
                                        />
                                    </div>
                                    {this.state.invalidState !== null ? (
                                        <div className="invalid">
                                            {this.state.invalidState}
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </MDBCol>
                                <MDBCol sm="12" lg="4">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Zip Code*
                                    </label>
                                    <input
                                        required
                                        name="postalcode"
                                        id="postalcode"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.postalcode}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid zipcode
                                    </div>
                                </MDBCol>
                            </MDBRow>
                            {/* <MDBRow>
                                <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Primary Contact - First Name
                                    </label>
                                    <input
                                        // required
                                        name="firstName"
                                        id="firstName"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.firstName}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a first name
                                    </div>
                                </MDBCol>
                                <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Primary Contact - Last Name
                                    </label>
                                    <input
                                        // required
                                        name="lastName"
                                        id="lastName"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.lastName}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a last name
                                    </div>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol col="6" sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Property Support Phone #
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            The phone number subscribers will
                                            see on support pages.
                                        </span>
                                    </MDBTooltip>
                                    <PhoneInput
                                        placeholder={t(
                                            "addnewresident.enterphone"
                                        )}
                                        value={this.state.phoneNumber}
                                        format={FORMAT}
                                        onChange={this.changeHandlerPhone}
                                        name="phoneNumber"
                                        id="phoneNumber"
                                        className={
                                            this.state.loading === true
                                                ? "form-control loading"
                                                : "form-control"
                                        }
                                        defaultCountry="US"
                                        // required
                                        error={
                                            this.state.phoneNumber
                                                ? isValidPhoneNumber(
                                                      this.state.phoneNumber
                                                  )
                                                    ? undefined
                                                    : "Invalid phone number"
                                                : "Phone number required"
                                        }
                                        disabled={this.state.userFoundWithPhone}
                                    />
                                    {this.state.invalidPhone !== null ? (
                                        <div className="invalid">
                                            {this.state.invalidPhone}
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </MDBCol>
                                <MDBCol sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Property Support E-mail
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            The e-mail address subscribers will
                                            see on support pages.
                                        </span>
                                    </MDBTooltip>
                                    <input
                                        // required
                                        name="email"
                                        id="email"
                                        className="form-control emailInput"
                                        onBlur={(event) =>
                                            this.validateEmail(this.state.email)
                                        }
                                        onChange={this.changeHandler}
                                        value={this.state.email}
                                    />
                                    {this.state.invalidEmail !== undefined ? (
                                        <div className="invalid">
                                            {this.state.invalidEmail}
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </MDBCol>
                            </MDBRow> */}
                            <h5 className="font-weight-bold pl-0 my-4">
                                <strong>Configuration Options</strong>
                            </h5>
                            <MDBRow>
                                <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Welcome E-mail Send Advance
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            Enter the number of hours prior to a
                                            subscriber’s service start time that
                                            you want them to receive their
                                            welcome e-mail. Enter 0 if you want
                                            the e-mails to be sent as soon as
                                            the subscriber is added
                                        </span>
                                    </MDBTooltip>
                                    <input
                                        required
                                        name="countdown"
                                        id="countdown"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.countdown}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid number
                                    </div>
                                </MDBCol>
                                <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Resident Devices VLAN Range *
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            This range will be used for dynamic
                                            VLANs if overlapping subscriptions
                                            is enabled. It will also be used to
                                            assign VLANs to units when adding a
                                            unit if you do not provide a VLAN
                                            when adding a unit.
                                        </span>
                                    </MDBTooltip>
                                    <MDBRow>
                                        <MDBCol col="6" sm="12" lg="6">
                                            <input
                                                required
                                                name="minVlanRes"
                                                id="minVlanRes"
                                                className="form-control"
                                                onChange={this.changeHandler}
                                                value={this.state.minVlanRes}
                                            />
                                        </MDBCol>
                                        <div className="invalid-feedback">
                                            Please provide a valid number
                                        </div>
                                        <MDBCol
                                            col="6"
                                            sm="12"
                                            lg="6"
                                            className="dash"
                                        >
                                            <input
                                                required
                                                name="maxVlanRes"
                                                id="maxVlanRes"
                                                className="form-control"
                                                onChange={this.changeHandler}
                                                value={this.state.maxVlanRes}
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <div className="invalid-feedback">
                                        Please provide a valid number
                                    </div>
                                </MDBCol>
                            </MDBRow>
                            {/* <MDBRow>
                                <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Default Subscription Duration (Hours) -{" "}
                                        <br />
                                        Residential Units
                                        <br />0 = unlimited
                                    </label>
                                    <input
                                        required
                                        name="durationResident"
                                        id="durationResident"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.durationResident}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid number
                                    </div>
                                </MDBCol>
                                <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Default Subscription Duration (Hours) -{" "}
                                        <br />
                                        Guest Subscriptions
                                        <br />0 = unlimited
                                    </label>
                                    <input
                                        required
                                        name="durationGuest"
                                        id="durationGuest"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.durationGuest}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid number
                                    </div>
                                </MDBCol>
                            </MDBRow> */}
                            <MDBRow>
                                <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Guest Devices VLAN Range *
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            Not Yet In Use: In a future update,
                                            this range will be used to
                                            dynamically assign VLANs to Guest
                                            devices
                                        </span>
                                    </MDBTooltip>
                                    <MDBRow>
                                        <MDBCol col="6" sm="12" lg="6">
                                            <input
                                                required
                                                name="minVlanGuest"
                                                id="minVlanGuest"
                                                className="form-control"
                                                onChange={this.changeHandler}
                                                value={this.state.minVlanGuest}
                                            />
                                            <div className="invalid-feedback">
                                                Please provide a valid number
                                            </div>
                                        </MDBCol>
                                        <MDBCol
                                            col="6"
                                            sm="12"
                                            lg="6"
                                            className="dash"
                                        >
                                            <input
                                                required
                                                name="maxVlanGuest"
                                                id="maxVlanGuest"
                                                className="form-control"
                                                onChange={this.changeHandler}
                                                value={this.state.maxVlanGuest}
                                            />
                                            <div className="invalid-feedback">
                                                Please provide a valid number
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>
                                <MDBCol col="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Roaming Devices VLAN Range *
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            Not Yet In Use: In a future update,
                                            this range will be used to
                                            dynamically assign VLANs to roaming
                                            devices
                                        </span>
                                    </MDBTooltip>
                                    <MDBRow>
                                        <MDBCol col="6" sm="12" lg="6">
                                            <input
                                                required
                                                name="minVlanRoaming"
                                                id="minVlanRoaming"
                                                className="form-control"
                                                onChange={this.changeHandler}
                                                value={
                                                    this.state.minVlanRoaming
                                                }
                                            />
                                            <div className="invalid-feedback">
                                                Please provide a valid number
                                            </div>
                                        </MDBCol>
                                        <MDBCol
                                            col="6"
                                            sm="12"
                                            lg="6"
                                            className="dash"
                                        >
                                            <input
                                                required
                                                name="maxVlanRoaming"
                                                id="maxVlanRoaming"
                                                className="form-control"
                                                onChange={this.changeHandler}
                                                value={
                                                    this.state.maxVlanRoaming
                                                }
                                            />
                                            <div className="invalid-feedback">
                                                Please provide a valid number
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                                <MDBCol
                                                    col="12"
                                                    sm="12"
                                                    lg="12"
                                                >
                                                    <label
                                                        htmlFor="defaultFormLoginEmailEx"
                                                        className="black-text"
                                                    >
                                                        External Venue ID{" "}
                                                    </label>
                                                    <input
                                                        id="externalVenueID"
                                                        name="externalVenueID"
                                                        className="form-control"
                                                        value={
                                                            this.state
                                                                .externalVenueID
                                                        }
                                                        onChange={
                                                         this.changeHandler
                                                        }
                                                    />
                                                    <span id="externalVenueIDHidden">
                                                        {
                                                            this.state
                                                                .externalVenueID
                                                        }
                                                    </span>
                                                </MDBCol>
                                            </MDBRow>
                            <MDBRow></MDBRow>
                            <MDBRow>
                                <MDBCol col="6" sm="12" lg="6">
                                    <MDBInput
                                        label="Send email for added subscriptions?"
                                        type="checkbox"
                                        id="sendSubscriptionAddedEmail"
                                        name="sendSubscriptionAddedEmail"
                                        onChange={
                                            this
                                                .toggleCheckboxValuesendSubscriptionAddedEmail
                                        }
                                        checked={
                                            this.state
                                                .sendSubscriptionAddedEmail
                                        }
                                    />
                                    <MDBInput
                                        label="Send email for ended subscriptions?"
                                        type="checkbox"
                                        id="sendSubscriptionEndEmail"
                                        name="sendSubscriptionEndEmail"
                                        onChange={
                                            this
                                                .toggleCheckboxValuesendSubscriptionEndedEmail
                                        }
                                        checked={
                                            this.state.sendSubscriptionEndEmail
                                        }
                                    />
                                </MDBCol>
                                <MDBCol col="6" sm="12" lg="6">
                                    <MDBInput
                                        label="Allow Overlapping Subscriptions"
                                        type="checkbox"
                                        id="allowOverlapping"
                                        name="allowOverlapping"
                                        onChange={
                                            this
                                                .toggleCheckboxValueAllowOverlapping
                                        }
                                        checked={this.state.allowOverlapping}
                                    >
                                        <MDBTooltip
                                            material
                                            placement="left"
                                            className="rightTooltip"
                                            style={{ display: "block" }}
                                        >
                                            <MDBIcon
                                                far
                                                icon="question-circle"
                                            />
                                            <span>
                                                Allow multiple subscribers to
                                                sign up for service in the same
                                                unit. If enabled, a temporary
                                                unit on a dynamic VLAN from the
                                                Residential Devices Range will
                                                be created while the
                                                subscription is overlapping.
                                            </span>
                                        </MDBTooltip>
                                    </MDBInput>
                                    <MDBInput
                                        label="Enable Broadband Label?"
                                        type="checkbox"
                                        id="displayFCCLabel"
                                        name="displayFCCLabel"
                                        onChange={
                                            this
                                                .toggleCheckboxValueDisplayFCCLabel
                                        }
                                        checked={this.state.displayFCCLabel}
                                        disabled={this.state.disabled}
                                    >
                                        <MDBTooltip
                                            material
                                            placement="left"
                                            className="rightTooltip"
                                            style={{ display: "block" }}
                                        >
                                            <MDBIcon
                                                far
                                                icon="question-circle"
                                            />
                                            <span>
                                                Enabling will show broadband
                                                labels for all service plans at
                                                the venue in the shopping cart
                                                and subscriber account settings
                                            </span>
                                        </MDBTooltip>
                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>
                            <br />
                            <MDBRow>
                                <MDBCol col="6" sm="12" lg="6">
                                    <label
                                        htmlFor="defaultFormLoginEmailEx"
                                        className="black-text"
                                    >
                                        Typical Latency
                                    </label>
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            The expected latency for
                                            subscribers. This field is required
                                            if the broadband label is enabled.
                                        </span>
                                    </MDBTooltip>
                                    <input
                                        // required
                                        name="typicalLatency"
                                        id="typicalLatency"
                                        className="form-control"
                                        onChange={this.changeHandler}
                                        value={this.state.typicalLatency}
                                        // disabled={!this.state.displayFCCLabel}
                                    />
                                    <div className="invalid-feedback">
                                        Please provide a valid number
                                    </div>
                                </MDBCol>
                            </MDBRow>
                            <br />
                            <div className="text-right submitButton">
                                <MDBBtn
                                    color="primary"
                                    onClick={this.props.toggleAddNewVenue}
                                >
                                    Cancel
                                </MDBBtn>
                                <MDBBtn
                                    color="danger"
                                    type="submit"
                                    className="float-right"
                                >
                                    {this.props.loading === true ? (
                                        <div
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </div>
                                    ) : (
                                        "Next"
                                    )}
                                </MDBBtn>
                            </div>
                        </form>
                    )}
                    {this.state.formActivePanel1 === 2 && (
                        <>
                            {this.state.lastProcessed > 0 ? (
                                <>
                                    <MDBModal
                                        isOpen={this.state.modalError}
                                        toggle={this.toggle}
                                        size="md"
                                        className="form"
                                        centered
                                    >
                                        <MDBModalHeader
                                            toggle={this.toggleError}
                                        >
                                            <h4>Error Uploading Units</h4>
                                        </MDBModalHeader>
                                        <MDBModalBody>
                                            {this.state.lastProcessed === 1 ? (
                                                <p>
                                                    Line{" "}
                                                    {this.state.lastProcessed}{" "}
                                                    (Unit:{" "}
                                                    {this.state.unitUnprocessed}
                                                    , Building:{" "}
                                                    {
                                                        this.state
                                                            .buildingUnprocessed
                                                    }
                                                    , Floor:{" "}
                                                    {
                                                        this.state
                                                            .floorUnprocessed
                                                    }
                                                    ) could not be processed.
                                                    <br />
                                        Reason: {this.state.errorMessage}
                                        <br />
                                                    Re-upload the CSV after
                                                    fixing line 1.
                                                </p>
                                            ) : (
                                                <p>
                                                    Line{" "}
                                                    {this.state.lastProcessed}{" "}
                                                    (Unit:{" "}
                                                    {this.state.unitUnprocessed}
                                                    , Building:{" "}
                                                    {
                                                        this.state
                                                            .buildingUnprocessed
                                                    }
                                                    , Floor:{" "}
                                                    {
                                                        this.state
                                                            .floorUnprocessed
                                                    }
                                                    ) could not be processed.
                                                    <br />
                                        Reason: {this.state.errorMessage}
                                        <br />
                                                    Re-upload the CSV after
                                                    fixing line{" "}
                                                    {this.state.lastProcessed}{" "}
                                                    and removing lines 1-
                                                    {this.state.lastProcessed -
                                                        1}
                                                    .
                                                </p>
                                            )}
                                        </MDBModalBody>
                                    </MDBModal>
                                </>
                            ) : (
                                ""
                            )}
                            {this.state.loading_upload === true ? (
                                <div
                                    className="overlay"
                                    id="overlay"
                                    style={{ display: "block" }}
                                >
                                    <div className="overlayProgressBar">
                                        <MDBProgress
                                            material
                                            value={this.state.progress}
                                            height="20px"
                                            color="danger"
                                            striped
                                        />
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {this.state.loading_upload === true ? (
                                <div
                                    className="overlay"
                                    id="overlay"
                                    style={{ display: "block" }}
                                >
                                    <div className="overlayProgressBar">
                                        <MDBProgress
                                            material
                                            value={this.state.progress}
                                            height="20px"
                                            color="danger"
                                            striped
                                        />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <h5 className="font-weight-bold pl-0 my-4">
                                        <strong>Upload Units</strong>
                                    </h5>
                                    <MDBRow>
                                        <MDBCol col="6" sm="12" lg="4">
                                            <h5>
                                                Venue Name:{" "}
                                                {sessionStorage.getItem(
                                                    "venueName"
                                                )}
                                            </h5>
                                        </MDBCol>
                                    </MDBRow>
                                    <br />
                                    <p>
                                        Please note, only CSV files are accepted
                                        for the upload. Fields marked with "*"
                                        in template are required.
                                    </p>
                                    <MDBModalBody>
                                        <div
                                            className="text-right submitButton"
                                            key={this.state.theInputKey || ""}
                                        >
                                            <MDBBtn
                                                color="primary"
                                                onClick={this.handleNextPrevClick(
                                                    1
                                                )(1)}
                                            >
                                                Previous
                                            </MDBBtn>
                                            <MDBBtn
                                                color="danger"
                                                onClick={() =>
                                                    this.exportCSVFile(
                                                        headers,
                                                        itemsFormatted,
                                                        fileTitle
                                                    )
                                                }
                                            >
                                                Download Template
                                            </MDBBtn>
                                            <MDBBtn color="danger">
                                                Upload Units
                                                <CSVReader
                                                    cssclassName="csv-reader-input"
                                                    onFileLoaded={
                                                        this.convertCSV
                                                    }
                                                    parserOptions={
                                                        papaparseOptions
                                                    }
                                                    inputId="csvVenueUnitUploadData"
                                                    inputStyle={{
                                                        color: "transparent",
                                                    }}
                                                />
                                            </MDBBtn>
                                            <MDBBtn
                                                color="primary"
                                                onClick={this.handleNextPrevClick(
                                                    1
                                                )(3)}
                                            >
                                                Next
                                            </MDBBtn>
                                        </div>
                                    </MDBModalBody>
                                </>
                            )}
                        </>
                    )}
                    {this.state.formActivePanel1 === 3 && (
                        <>
                            <h5 className="font-weight-bold pl-0 my-4">
                                <strong>Service Plans</strong>
                            </h5>
                            {this.state.disable_serviceplans === true ||
                            this.state.loading === true ? (
                                <div id="overlay" style={{ display: "block" }}>
                                    <div className="overlayMessage">
                                        <div
                                            className="spinner-border spinner-border"
                                            role="status"
                                        >
                                            <span className="sr-only">
                                                Loading...
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            <MDBModal
                                isOpen={this.state.modalAddServicePlanToVenue}
                                toggle={this.toggle}
                                size="fluid"
                                className="form"
                                centered
                            >
                                <AddServicePlanToVenue
                                    toggleAddServicePlan={
                                        this.toggleAddServicePlanToVenue
                                    }
                                    venueName={this.props.venueName}
                                    submitAddServicePlan={
                                        this.submitAddServicePlanToVenue
                                    }
                                    add_serviceplan={this.state.add_serviceplan}
                                    servicePlans={this.props.servicePlans}
                                />
                            </MDBModal>
                            <MDBModal
                                isOpen={this.state.modalAddServicePlan}
                                toggle={this.toggle}
                                size="fluid"
                                className="form"
                                centered
                            >
                                <AddServicePlan
                                    toggleAddServicePlan={
                                        this.toggleAddServicePlan
                                    }
                                    venueName={this.props.venueName}
                                    submitAddServicePlan={
                                        this.submitAddServicePlan
                                    }
                                    add_serviceplan={this.state.add_serviceplan}
                                    servicePlans={this.props.servicePlans}
                                />
                            </MDBModal>
                            {this.props.servicePlans !== undefined ? (
                                <>
                                    <div className="servicePlans">
                                        <MDBRow>
                                            <MDBCol col="6" sm="12" lg="4">
                                                <h5>
                                                    Venue Name:{" "}
                                                    {sessionStorage.getItem(
                                                        "venueName"
                                                    )}
                                                </h5>
                                            </MDBCol>
                                        </MDBRow>
                                        <br />
                                        <MDBRow>
                                            <MDBCol col="4">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Default Service Plan:
                                                    Residential Units
                                                </label>
                                                <SelectSearch
                                                    id="selectDefaultServicePlanResident"
                                                    search={true}
                                                    filterOptions={fuzzySearch}
                                                    options={
                                                        this.state
                                                            .optionTemplateServicePlans
                                                    }
                                                    inputId="groupArray"
                                                    classNamePrefix="group-select"
                                                    onChange={
                                                        this
                                                            .handleSelectDefaultServicePlanResident
                                                    }
                                                    value={
                                                        this.props
                                                            .selectDefaultServicePlanResident
                                                    }
                                                    placeholder="Select..."
                                                />
                                            </MDBCol>
                                            <MDBCol col="4">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Default Service Plan: Guest
                                                    Subscription
                                                </label>
                                                <SelectSearch
                                                    id="selectDefaultServicePlanWireless"
                                                    search={true}
                                                    filterOptions={fuzzySearch}
                                                    options={
                                                        this.state
                                                            .optionTemplateServicePlans
                                                    }
                                                    inputId="groupArray"
                                                    classNamePrefix="group-select"
                                                    onChange={
                                                        this
                                                            .handleSelectDefaultServicePlanWireless
                                                    }
                                                    value={
                                                        this.props
                                                            .selectDefaultServicePlanWireless
                                                    }
                                                    placeholder="Select..."
                                                />
                                            </MDBCol>
                                            <MDBCol col="4">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Default Service Plan: Roaming
                                                    Subscription
                                                </label>
                                                <SelectSearch
                                                    id="selectDefaultServicePlanRoaming"
                                                    search={true}
                                                    filterOptions={fuzzySearch}
                                                    options={
                                                        this.state
                                                            .optionTemplateServicePlans
                                                    }
                                                    inputId="groupArray"
                                                    classNamePrefix="group-select"
                                                    onChange={
                                                        this
                                                            .handleSelectDefaultServicePlanRoaming
                                                    }
                                                    value={
                                                        this.props
                                                            .selectDefaultServicePlanRoaming
                                                    }
                                                    placeholder="Select..."
                                                />
                                            </MDBCol>
                                        </MDBRow>
                                        <br />
                                        <VenueServicePlansTable
                                            servicePlans={
                                                this.props.servicePlans
                                            }
                                            refreshed={this.props.refreshed}
                                            disablePlanConfirm={
                                                this.disablePlanConfirm
                                            }
                                            currencyName={
                                                this.props.currencyName
                                            }
                                        />
                                    </div>
                                </>
                            ) : <>
                                    <div className="servicePlans">
                                        <MDBRow>
                                            <MDBCol col="6" sm="12" lg="4">
                                                <h5>
                                                    Venue Name:{" "}
                                                    {sessionStorage.getItem(
                                                        "venueName"
                                                    )}
                                                </h5>
                                            </MDBCol>
                                        </MDBRow>
                                        <br />
                                        <MDBRow>
                                            <MDBCol col="4">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Default Service Plan:
                                                    Residential Units
                                                </label>
                                                <SelectSearch
                                                    id="selectDefaultServicePlanResident"
                                                    search={true}
                                                    filterOptions={fuzzySearch}
                                                    options={
                                                        this.state
                                                            .optionTemplateServicePlans
                                                    }
                                                    inputId="groupArray"
                                                    classNamePrefix="group-select"
                                                    onChange={
                                                        this
                                                            .handleSelectDefaultServicePlanResident
                                                    }
                                                    value={
                                                        this.props
                                                            .selectDefaultServicePlanResident
                                                    }
                                                    placeholder="Select..."
                                                />
                                            </MDBCol>
                                            <MDBCol col="4">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Default Service Plan: Guest
                                                    Subscription
                                                </label>
                                                <SelectSearch
                                                    id="selectDefaultServicePlanWireless"
                                                    search={true}
                                                    filterOptions={fuzzySearch}
                                                    options={
                                                        this.state
                                                            .optionTemplateServicePlans
                                                    }
                                                    inputId="groupArray"
                                                    classNamePrefix="group-select"
                                                    onChange={
                                                        this
                                                            .handleSelectDefaultServicePlanWireless
                                                    }
                                                    value={
                                                        this.props
                                                            .selectDefaultServicePlanWireless
                                                    }
                                                    placeholder="Select..."
                                                />
                                            </MDBCol>
                                            <MDBCol col="4">
                                                <label
                                                    htmlFor="defaultFormLoginEmailEx"
                                                    className="black-text"
                                                >
                                                    Default Service Plan: Roaming
                                                    Subscription
                                                </label>
                                                <SelectSearch
                                                    id="selectDefaultServicePlanRoaming"
                                                    search={true}
                                                    filterOptions={fuzzySearch}
                                                    options={
                                                        this.state
                                                            .optionTemplateServicePlans
                                                    }
                                                    inputId="groupArray"
                                                    classNamePrefix="group-select"
                                                    onChange={
                                                        this
                                                            .handleSelectDefaultServicePlanRoaming
                                                    }
                                                    value={
                                                        this.props
                                                            .selectDefaultServicePlanRoaming
                                                    }
                                                    placeholder="Select..."
                                                />
                                            </MDBCol>
                                        </MDBRow>
                                        <br />
                                        <VenueServicePlansTable
                                            servicePlans={
                                                this.props.servicePlans
                                            }
                                            refreshed={this.props.refreshed}
                                            disablePlanConfirm={
                                                this.disablePlanConfirm
                                            }
                                            currencyName={
                                                this.props.currencyName
                                            }
                                        />
                                    </div>
                                </>}
                            <MDBBtn
                                className="btn-right btn-danger"
                                color="primary"
                                onClick={this.handleNextPrevClick(1)(4)}
                            >
                                Next
                            </MDBBtn>
                            <MDBBtn
                                onClick={this.toggleAddServicePlan}
                                className="btn-right btn-danger"
                            >
                                Create new service plan
                            </MDBBtn>
                            <MDBBtn
                                onClick={this.toggleAddServicePlanToVenue}
                                className="btn-right btn-danger"
                            >
                                Add Exisiting Service Plan
                            </MDBBtn>
                            <MDBBtn
                                className="btn-right btn-danger"
                                color="primary"
                                onClick={this.handleNextPrevClick(1)(2)}
                            >
                                Previous
                            </MDBBtn>
                        </>
                    )}
                    {this.state.formActivePanel1 === 4 && (
                        <>
                            <MDBModal
                                isOpen={this.state.modalModifyEquipment}
                                toggle={this.toggle}
                                size="lg"
                                className="form"
                                centered
                            >
                                <ModifyEquipment
                                    toggleModifyEquipment={
                                        this.toggleModifyEquipment
                                    }
                                    equipID={this.state.equipID}
                                    venueName={this.props.venueName}
                                    submitModifyEquipment={
                                        this.submitModifyEquipment
                                    }
                                    modify_equipment={
                                        this.state.modify_equipment
                                    }
                                    venueEquipList={this.state.venueEquipList}
                                />
                            </MDBModal>
                            <MDBModal
                                isOpen={this.state.modalAddVenueEquipment}
                                toggle={this.toggle}
                                size="lg"
                                className="form"
                                centered
                            >
                                <AddVenueEquipment
                                    toggleAddVenueEquipment={
                                        this.toggleAddVenueEquipment
                                    }
                                    venueName={this.props.venueName}
                                    submitAddVenueEquipment={
                                        this.submitAddVenueEquipment
                                    }
                                    add_venueequip={this.state.add_venueequip}
                                />
                            </MDBModal>
                            {!this.props.loading ? (
                                <>
                                    <h5 className="font-weight-bold pl-0 my-4">
                                        <strong>Equipment</strong>
                                    </h5>
                                    <MDBRow>
                                        <MDBCol col="6" sm="12" lg="4">
                                            <h5>
                                                Venue Name:{" "}
                                                {sessionStorage.getItem(
                                                    "venueName"
                                                )}
                                            </h5>
                                        </MDBCol>
                                    </MDBRow>
                                    <br />
                                    <div className="servicePlans">
                                        <VenueEquipmentTable
                                            venueEquipList={
                                                this.state.venueEquipList
                                            }
                                            refreshed={this.props.refreshed}
                                            modifyEquipment={
                                                this.modifyEquipment
                                            }
                                        />
                                    </div>
                                </>
                            ) : (
                                <MDBSpinner small />
                            )}
                            <MDBBtn
                                className="btn-right btn-danger"
                                color="primary"
                                onClick={this.handleNextPrevClick(1)(5)}
                            >
                                Next
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.toggleAddVenueEquipment}
                                className="btn-right"
                            >
                                Add Equipment
                            </MDBBtn>
                            <MDBBtn
                                className="btn-right btn-danger"
                                color="primary"
                                onClick={this.handleNextPrevClick(1)(3)}
                            >
                                Previous
                            </MDBBtn>
                        </>
                    )}
                    {this.state.formActivePanel1 === 5 && (
                        <>
                            <h5 className="font-weight-bold pl-0 my-4">
                                <strong>Shopping Cart</strong>
                            </h5>
                            <MDBRow>
                                <MDBCol col="6" sm="12" lg="4">
                                    <h5>
                                        Venue Name:{" "}
                                        {sessionStorage.getItem("venueName")}
                                    </h5>
                                </MDBCol>
                            </MDBRow>
                            <br />
                            <form
                                className="needs-validation"
                                onSubmit={this.handleNextPrevClick(1)(6)}
                                noValidate
                            >
                                <MDBInput
                                    label="Enable shopping cart?"
                                    type="checkbox"
                                    id="enableShoppingCart"
                                    name="enableShoppingCart"
                                    onChange={
                                        this
                                            .toggleCheckboxValueEnableShoppingCart
                                    }
                                    checked={this.state.enableShoppingCart}
                                >
                                    <MDBTooltip
                                        material
                                        placement="left"
                                        className="rightTooltip"
                                        style={{ display: "block" }}
                                    >
                                        <MDBIcon far icon="question-circle" />
                                        <span>
                                            The venue will display in your
                                            shopping cart for self sign up
                                        </span>
                                    </MDBTooltip>
                                </MDBInput>
                                <br />
                                <MDBRow>
                                    <MDBCol col="6" sm="12" lg="6">
                                        <label
                                            htmlFor="defaultFormLoginEmailEx"
                                            className="black-text"
                                        >
                                            Shopping Cart Price Discount ({this.props.currencyName})
                                        </label>
                                        <MDBTooltip
                                            material
                                            placement="left"
                                            className="rightTooltip"
                                            style={{ display: "block" }}
                                        >
                                            <MDBIcon
                                                far
                                                icon="question-circle"
                                            />
                                            <span>
                                                Apply a discount to all service
                                                plan billing cycle prices at
                                                this venue.
                                            </span>
                                        </MDBTooltip>
                                        <input
                                            type="number"
                                            id="shoppingCartPriceAdjustment"
                                            name="shoppingCartPriceAdjustment"
                                            className="form-control"
                                            onChange={this.changeHandler}
                                            value={
                                                -Math.abs(
                                                    this.state
                                                        .shoppingCartPriceAdjustment
                                                )
                                            }
                                        />
                                        <div className="invalid-feedback">
                                            Please provide a value.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol col="6" sm="12" lg="6">
                                        <label
                                            htmlFor="defaultFormLoginEmailEx"
                                            className="black-text"
                                        >
                                            Trial Cycles Adjustments
                                        </label>
                                        <MDBTooltip
                                            material
                                            placement="left"
                                            className="rightTooltip"
                                            style={{ display: "block" }}
                                        >
                                            <MDBIcon
                                                far
                                                icon="question-circle"
                                            />
                                            <span>
                                                Adjust trial cycles for all
                                                services plans at this venue
                                            </span>
                                        </MDBTooltip>
                                        <SelectSearch
                                            id="selectTrialCycles"
                                            search={true}
                                            filterOptions={fuzzySearch}
                                            options={
                                                this.state.trialCyclesOptions
                                            }
                                            inputId="trialCycleArray"
                                            classNamePrefix="unit-select form-control"
                                            onChange={
                                                this.handleSelectTrialCycles
                                            }
                                            value={
                                                this.state.selectedTrialCycles
                                            }
                                            placeholder="Please select..."
                                        />
                                        <div className="invalid-feedback">
                                            Please provide a value
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol col="6" sm="12" lg="6">
                                        <label
                                            htmlFor="defaultFormLoginEmailEx"
                                            className="black-text"
                                        >
                                            Stripe Publishable Key
                                        </label>
                                        <input
                                            id="stripePublishableKey"
                                            name="stripePublishableKey"
                                            className="form-control"
                                            onChange={this.changeHandler}
                                            value={
                                                this.state.stripePublishableKey
                                            }
                                        />
                                        <div className="invalid-feedback">
                                            Please provide a value.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol col="6" sm="12" lg="6">
                                        <label
                                            htmlFor="defaultFormLoginEmailEx"
                                            className="black-text"
                                        >
                                            Stripe Secret Key
                                        </label>
                                        <input
                                            id="stripeSecretKey"
                                            name="stripeSecretKey"
                                            className="form-control"
                                            onChange={this.changeHandler}
                                            value={this.state.stripeSecretKey}
                                        />
                                        <div className="invalid-feedback">
                                            Please provide a value.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol col="6" sm="12" lg="6">
                                        <label
                                            htmlFor="defaultFormLoginEmailEx"
                                            className="black-text"
                                        >
                                            Stripe Webhook Signing Secret
                                        </label>
                                        <input
                                            id="stripeWebhookSigningSecret"
                                            name="stripeWebhookSigningSecret"
                                            className="form-control"
                                            onChange={this.changeHandler}
                                            value={
                                                this.state
                                                    .stripeWebhookSigningSecret
                                            }
                                        />
                                        <div className="invalid-feedback">
                                            Please provide a value.
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <div className="text-right submitButton">
                                    <MDBBtn
                                        className="btn-right btn-danger"
                                        color="primary"
                                        type="submit"
                                    >
                                        {!this.props.loading ? (
                                            <>Save (Next)</>
                                        ) : (
                                            <MDBSpinner small />
                                        )}
                                    </MDBBtn>
                                    <MDBBtn
                                        className="btn-right btn-danger"
                                        color="primary"
                                        onClick={this.handleNextPrevClick(1)(4)}
                                    >
                                        Previous
                                    </MDBBtn>
                                </div>
                            </form>
                        </>
                    )}
                    {this.state.formActivePanel1 === 6 && (
                        <>
                            <h5 className="font-weight-bold pl-0 my-4">
                                <strong>Keypools</strong>
                            </h5>
                            <MDBRow>
                                <MDBCol col="6" sm="12" lg="4">
                                    <h5>
                                        Venue Name:{" "}
                                        {sessionStorage.getItem("venueName")}
                                    </h5>
                                </MDBCol>
                            </MDBRow>
                            <br />
                            <MDBModal
                                isOpen={this.state.modalAddKeypool}
                                toggle={this.toggle}
                                size="md"
                                className="form"
                                centered
                            >
                                <AddKeypool
                                    toggleAddKeypool={this.toggleAddKeypool}
                                    venueName={this.props.venueName}
                                    submitAddKeypool={this.submitAddKeypool}
                                    submitAssignKeypool={this.submitAssignKeypool}
                                    add_keypool={this.state.add_keypool}
                                    loadingAddKeypool={
                                        this.state.loadingAddKeypool
                                    }
                                    localOnly={true}
                                    allKeypools={this.state.allKeypools}
                                />
                            </MDBModal>
                            {!this.props.loading ? (
                                <>
                                    <div className="servicePlans">
                                        <VenueKeypoolsTable
                                            keyPoolList={this.state.keyPoolList}
                                            refreshed={this.props.refreshed}
                                            disablePlanConfirm={
                                                this.disablePlanConfirm
                                            }
                                        />
                                    </div>
                                </>
                            ) : (
                                <MDBSpinner small />
                            )}
                            <MDBBtn
                                className="btn-right btn-danger"
                                color="primary"
                                onClick={this.handleNextPrevClick(1)(7)}
                            >
                                Next
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.toggleAddKeypool}
                                className="btn-right"
                            >
                                Add Keypool
                            </MDBBtn>
                            <MDBBtn
                                className="btn-right btn-danger"
                                color="primary"
                                onClick={this.handleNextPrevClick(1)(5)}
                            >
                                Previous
                            </MDBBtn>
                        </>
                    )}
                    {this.state.formActivePanel1 === 7 && (
                        <>
                            <h5 className="font-weight-bold pl-0 my-4">
                                <strong>PMS</strong>
                            </h5>
                            <MDBRow>
                                <MDBCol col="6" sm="12" lg="4">
                                    <h5>
                                        Venue Name:{" "}
                                        {sessionStorage.getItem("venueName")}
                                    </h5>
                                </MDBCol>
                            </MDBRow>
                            <br />
                            <form
                                className="needs-validation"
                                onSubmit={this.handleNextPrevClick(1)(8)}
                                noValidate
                            >
                                {/* PMS Profile Selection Section */}
                                <h5 className="font-weight-bold pl-0 mt-1 mb-3">
                                    <strong>PMS Profile Selection</strong>
                                </h5>
                                
                                <MDBRow>
                                    <MDBCol col="6" sm="12" lg="6">
                                        <label
                                            htmlFor="pmsProfileSelect"
                                            className="black-text"
                                        >
                                            PMS Profile Configuration
                                        </label>
                                        <SelectSearch
                                            id="pmsProfileSelect"
                                            search={true}
                                            filterOptions={fuzzySearch}
                                            options={this.state.pmsProfileOptions || []}
                                            isOptionSelected={true}
                                            inputId="pmsProfileArray"
                                            classNamePrefix="pms-profile-select"
                                            placeholder="Loading PMS profiles..."
                                            onChange={this.handleSelectPMSProfile}
                                            value={this.state.selectedPMSProfile || " "}
                                        />
                                        {!this.state.selectedPMSProfile || this.state.selectedPMSProfile === "" ? (
                                            <small className="form-text text-muted">
                                                No PMS integration configured. Select a profile to enable PMS sync features.
                                            </small>
                                        ) : (
                                            <small className="form-text text-success">
                                                <MDBIcon icon="check-circle" className="mr-1" />
                                                PMS profile selected. Configure venue-specific settings below.
                                            </small>
                                        )}
                                        <div className="invalid-feedback">
                                            Please select a valid PMS configuration option.
                                        </div>
                                    </MDBCol>
                                </MDBRow>

                                {/* Selected Profile Info Section */}
                                {this.state.selectedPMSProfileInfo && (
                                    <>
                                        <br />
                                        <h5 className="font-weight-bold pl-0 mt-3 mb-2">
                                            <strong>Selected Profile Information</strong>
                                        </h5>
                                        <div className="profile-info-card p-3 mb-3">
                                            <MDBRow>
                                                <MDBCol col="6">
                                                    <p><strong>Profile Name:</strong> {this.state.selectedPMSProfileInfo.ProfileName}</p>
                                                    <p><strong>Type:</strong> {this.state.selectedPMSProfileInfo.Type}</p>
                                                    <p><strong>Enable Sync:</strong> {this.state.selectedPMSProfileInfo.enableSync ? 'true' : 'false'}</p>
                                                </MDBCol>
                                                <MDBCol col="6">
                                                    {this.state.selectedPMSProfileInfo.Type?.toLowerCase() === 'entrata' && (
                                                        <>
                                                            <p><strong>Domain:</strong> {this.state.selectedPMSProfileInfo.EntrataSubdomain || 'N/A'}</p>
                                                            <p><strong>API Key:</strong> {this.state.selectedPMSProfileInfo.EntrataAPIKey || 'N/A'}</p>
                                                        </>
                                                    )}
                                                    {this.state.selectedPMSProfileInfo.Type?.toLowerCase() === 'realpage' && (
                                                        <>
                                                            <p><strong>URL:</strong> {this.state.selectedPMSProfileInfo.RealPageURL || 'N/A'}</p>
                                                            <p><strong>API Key:</strong> {this.state.selectedPMSProfileInfo.RealPageAPIKey || 'N/A'}</p>
                                                            <p><strong>PMC ID:</strong> {this.state.selectedPMSProfileInfo.RealPagePMCId || 'N/A'}</p>
                                                        </>
                                                    )}
                                                </MDBCol>
                                            </MDBRow>
                                        </div>
                                    </>
                                )}

                                {/* Venue-Specific Configuration Section */}
                                {this.state.selectedPMSProfileInfo && (
                                    <>
                                        <br />
                                        <h5 className="font-weight-bold pl-0 mt-3 mb-2">
                                            <strong>Venue Configuration*</strong>
                                        </h5>
                                        
                                        <MDBRow>
                                            <MDBCol col="6" sm="12" lg="6">
                                                {this.state.selectedPMSProfileInfo.Type?.toLowerCase() === 'entrata' && (
                                                    <>
                                                        <label className="black-text">
                                                            Entrata Property ID *
                                                        </label>
                                                        <input
                                                            type="text"
                                                            required
                                                            className="form-control"
                                                            name="entrataPropertyId"
                                                            value={this.state.entrataPropertyId || ''}
                                                            onChange={this.changeHandler}
                                                            placeholder="Enter Entrata Property ID"
                                                        />
                                                        <div className="invalid-feedback">
                                                            Please provide a valid Entrata Property ID
                                                        </div>
                                                        <small className="form-text text-muted">
                                                            This ID identifies your specific property within Entrata
                                                        </small>
                                                    </>
                                                )}
                                                
                                                {this.state.selectedPMSProfileInfo.Type?.toLowerCase() === 'realpage' && (
                                                    <>
                                                        <label className="black-text">
                                                            RealPage Site ID *
                                                        </label>
                                                        <input
                                                            type="text"
                                                            required
                                                            className="form-control"
                                                            name="realpageSiteId"
                                                            value={this.state.realpageSiteId || ''}
                                                            onChange={this.changeHandler}
                                                            placeholder="Enter RealPage Site ID"
                                                        />
                                                        <div className="invalid-feedback">
                                                            Please provide a valid RealPage Site ID
                                                        </div>
                                                        <small className="form-text text-muted">
                                                            This ID identifies your specific site within RealPage
                                                        </small>
                                                    </>
                                                )}
                                            </MDBCol>
                                        </MDBRow>
                                    </>
                                )}

                                {/* PMS Sync Options Section */}
                                <h5 className="font-weight-bold pl-0 mt-3 mb-2">
                                    <strong>PMS Sync Options</strong>
                                </h5>
                                
                                {!this.state.selectedPMSProfile || this.state.selectedPMSProfile === "" || this.state.selectedPMSProfile === " " ? (
                                    <div className="alert alert-info" role="alert">
                                        <MDBIcon icon="info-circle" className="mr-2" />
                                        <strong>No PMS Profile Selected:</strong> PMS sync options are disabled. Please select a PMS profile above to configure sync settings.
                                    </div>
                                ) : (
                                    <MDBRow>
                                        <MDBCol col="12" sm="12" lg="6">
                                            <MDBInput
                                                label="Enable Unit Sync"
                                                type="checkbox"
                                                id="enablePMSUnitSync"
                                                name="pmsUnitSync"
                                                onChange={this.changeHandlerUnitSync}
                                                checked={this.state.PMSEnableUnitSync}
                                                disabled={!this.state.selectedPMSProfile || this.state.selectedPMSProfile === " " || this.state.PMSEnableSubscriberSync}
                                            >
                                                <MDBTooltip
                                                    material
                                                    placement="right"
                                                    className="rightTooltip pms-sync-tooltip"
                                                >
                                                    <MDBIcon far icon="question-circle" />
                                                    <span>
                                                        {this.state.PMSEnableSubscriberSync 
                                                            ? "Required for Subscriber Sync - automatically enabled and locked" 
                                                            : "Sync unit inventory from PMS"}
                                                    </span>
                                                </MDBTooltip>
                                            </MDBInput>
                                            <MDBInput
                                                label="Enable Subscriber Sync"
                                                type="checkbox"
                                                id="enablePMSSubscriberSync"
                                                name="pmsSubscriberSync"
                                                onChange={this.changeHandlerSubscriberSync}
                                                checked={this.state.PMSEnableSubscriberSync}
                                                disabled={!this.state.selectedPMSProfile || this.state.selectedPMSProfile === " "}
                                            >
                                                <MDBTooltip
                                                    material
                                                    placement="right"
                                                    className="rightTooltip pms-sync-tooltip"
                                                >
                                                    <MDBIcon far icon="question-circle" />
                                                    <span>Sync subscribers from PMS (requires Unit Sync to be enabled)</span>
                                                </MDBTooltip>
                                            </MDBInput>
                                        </MDBCol>
                                    </MDBRow>
                                )}

                                <br />

                                {/* Blacklisted Email IDs Section - Only show when Enable subscriber sync is checked */}
                                {/* {this.state.PMSEnableSubscriberSync && (
                                 <>
                                  <h5 className="font-weight-bold pl-0 mt-3 mb-2">
                                   <strong>Blacklisted Email IDs</strong>
                                  </h5>
                                  <div className="blacklist-emails-container p-3 mb-3">
                                   <div className="mb-3">
                                    <label className="black-text" htmlFor="blacklistedEmailInput">
                                     Add Email Address
                                    </label>
                                    <div className="blacklist-emails-input-wrapper">
                                     <input
                                      type="email"
                                      id="blacklistedEmailInput"
                                      className="form-control"
                                      placeholder="Enter email address"
                                      value={this.state.PMSBlacklistedEmailInput}
                                      onChange={this.handleBlacklistedEmailInput}
                                      onKeyPress={this.handleAddBlacklistedEmail}
                                     />
                                     <MDBBtn
                                      color="primary"
                                      size="sm"
                                      onClick={this.handleAddBlacklistedEmail}
                                      className="btn-nowrap"
                                     >
                                      <MDBIcon icon="plus" className="mr-2" />
                                      Add
                                     </MDBBtn>
                                    </div>
                                   </div>
                                   {this.state.PMSBlacklistedEmails.length > 0 && (
                                    <div className="blacklisted-emails-list">
                                     <label className="black-text mb-2">Added Emails:</label>
                                     <div className="blacklisted-emails-chips-wrapper">
                                      {this.state.PMSBlacklistedEmails.map((email, index) => (
                                       <div
                                        key={index}
                                        className="blacklisted-email-chip"
                                       >
                                        <span>{email}</span>
                                        <MDBIcon
                                         icon="times"
                                         className="blacklisted-email-chip-icon"
                                         onClick={() => this.handleRemoveBlacklistedEmail(email)}
                                        />
                                       </div>
                                      ))}
                                     </div>
                                    </div>
                                   )}
                                  </div>
                                 </>
                                )} */}

                                <br />

                                <div className="text-right submitButton">
                                    <MDBBtn
                                        className="btn-right btn-danger"
                                        type="submit"
                                        color="primary"
                                        onClick={this.handleNextPrevClick(1)(8)}
                                    >
                                        Save (Next)
                                    </MDBBtn>
                                    <MDBBtn
                                        className="btn-right btn-danger"
                                        color="primary"
                                        onClick={this.handleNextPrevClick(1)(6)}
                                    >
                                        Previous
                                    </MDBBtn>
                                </div>
                            </form>
                        </>
                    )}
                    {this.state.formActivePanel1 === 8 && (
                        <>
                            <h5 className="font-weight-bold pl-0 my-4">
                                <strong>Administrators</strong>
                            </h5>
                            <MDBRow>
                                <MDBCol col="6" sm="12" lg="4">
                                    <h5>
                                        Venue Name:{" "}
                                        {sessionStorage.getItem("venueName")}
                                    </h5>
                                </MDBCol>
                            </MDBRow>
                            <br />
                            {this.state.toggleConfirm ? (
                                <MDBModal
                                    isOpen={this.state.modal}
                                    toggle={this.toggle}
                                >
                                    <MDBModalHeader toggle={this.toggle}>
                                        Confirm Disable
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <p>Email: {this.state.confirmEmail}</p>
                                    </MDBModalBody>
                                    <MDBModalFooter>
                                        <MDBBtn
                                            color="primary"
                                            onClick={() =>
                                                this.toggleDisable(
                                                    this.state.confirmEmail
                                                )
                                            }
                                        >
                                            Confirm
                                        </MDBBtn>
                                        <MDBBtn
                                            color="primary"
                                            onClick={this.toggle}
                                        >
                                            Close
                                        </MDBBtn>
                                    </MDBModalFooter>
                                </MDBModal>
                            ) : null}
                            <MDBModal
                                isOpen={this.state.modalAddVenueAdministrators}
                                toggle={this.toggle}
                                size="lg"
                                className="form"
                                centered
                            >
                                <AddVenueAdministrator
                                    toggleAddVenueAdministrators={
                                        this.toggleAddVenueAdministrators
                                    }
                                    venueName={this.props.venueName}
                                    submitAddVenueAdministrators={
                                        this.submitAddVenueAdministrators
                                    }
                                    add_venueadmin={this.state.add_venueadmin}
                                />
                            </MDBModal>
                            {!this.props.loading ? (
                                <>
                                    <div className="servicePlans">
                                        <VenueAdministratorsTable
                                            staff={this.state.staffArrayAll}
                                            refreshed={this.props.refreshed}
                                            toggleDisable={
                                                this.toggleConfirmDisable
                                            }
                                        />
                                    </div>
                                </>
                            ) : (
                                <MDBSpinner small />
                            )}
                            <MDBBtn
                                className="btn-right btn-danger"
                                color="primary"
                                onClick={this.props.toggleAddNewVenue}
                            >
                                Finish
                            </MDBBtn>
                            <MDBBtn
                                color="primary"
                                onClick={this.toggleAddVenueAdministrators}
                                className="btn-right"
                            >
                                Add Administrator
                            </MDBBtn>
                            <MDBBtn
                                className="btn-right btn-danger"
                                color="primary"
                                onClick={this.handleNextPrevClick(1)(7)}
                            >
                                Previous
                            </MDBBtn>
                        </>
                    )}
                </MDBModalBody>
                {/* Service Plans Loading Modal */}
                <MDBModal
                    isOpen={this.state.modalServicePlansLoading}
                    size="md"
                    className="form"
                    centered
                    backdrop="static"
                    keyboard={false}
                >
                    <MDBModalBody className="text-center" style={{ padding: "2rem" }}>
                        <div className="spinner-border text-danger mb-3" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <h5 className="mb-1">Retrieving Service Plans&hellip;</h5>
                        <p className="text-muted mb-3" style={{ fontSize: "0.9rem" }}>
                            {this.state.servicePlansElapsedSeconds < 10
                                ? "Service plans are being retrieved for this venue."
                                : this.state.servicePlansElapsedSeconds < 30
                                ? "This is taking a bit longer than usual — hang tight."
                                : "Still working on it. Service plans can take up to a minute after venue creation."}
                        </p>
                        <div style={{ marginBottom: "0.5rem" }}>
                            <MDBProgress
                                material
                                value={Math.min(
                                    Math.round((this.state.servicePlansRetryCount / this.state.servicePlansMaxRetries) * 100),
                                    100
                                )}
                                height="12px"
                                color="danger"
                                striped
                                animated
                            />
                        </div>
                        <small className="text-muted">
                            Elapsed: {this.state.servicePlansElapsedSeconds}s
                            {" "}·{" "}
                            Attempt {this.state.servicePlansRetryCount + 1} of {this.state.servicePlansMaxRetries}
                        </small>
                    </MDBModalBody>
                </MDBModal>
            </>
        );
    }
}
export default withTranslation()(AddVenue);
